
import { MapModule_ValuesL, MapModule_KeysL } from "./EEExtensions.js";
import { concat, max as max_2, sumBy, exists, mapIndexed, mapIndexed2, length, fold, ofArray, tryFindIndex, initialize, singleton, filter, map as map_2, tryPick, collect, item, empty, cons, head, tail, isEmpty, tryFind, ofSeq } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { fold as fold_1, add, FSharpMap__get_Item, empty as empty_1, FSharpMap__Add, ofList as ofList_1, tryFind as tryFind_1, ofSeq as ofSeq_1, FSharpMap__TryFind, toSeq } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { toText, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { defaultArg, value as value_1 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { ComponentType, WidthInferError } from "./CommonTypes.js";
import { Result_Map, Result_Bind, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { toList, ofList, append } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { safeHash, comparePrimitives, compare, stringHash, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { max as max_1 } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { fromInt32, toInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { clog2 } from "./ParameterTypes.js";
import { checkedMap3 } from "../Shared/ListPairs.js";
import { ResultList_sequence } from "./Helpers.js";
import { instrumentInterval, getTimeMs } from "./TimeHelpers.js";

export function mapKeys(map) {
    return MapModule_KeysL(map);
}

export function mapValues(map) {
    return MapModule_ValuesL(map);
}

export function mapItems(map) {
    return ofSeq(toSeq(map));
}

function extractComponentPortNumber(port) {
    const matchValue = port.PortNumber;
    if (matchValue != null) {
        return matchValue | 0;
    }
    else {
        return toFail(printf("what? extractComponentPortNumber should always be called with component ports: %A"))(port) | 0;
    }
}

function assertInputsSize(inputs, expected, comp) {
}

function getOutputPortId(comp, idx) {
    const matchValue = tryFind((p) => (extractComponentPortNumber(p) === idx), comp.OutputPorts);
    if (matchValue != null) {
        return matchValue.Id;
    }
    else {
        return toFail(printf("what? getOutputPortId called with inexistent port idx (%d): %A "))(idx)(comp);
    }
}

function getWidthsForPorts(inputs, portNumbers) {
    if (!isEmpty(portNumbers)) {
        const portNumbers$0027 = tail(portNumbers);
        const portNumber = head(portNumbers);
        const matchValue = FSharpMap__TryFind(inputs, portNumber);
        if (matchValue != null) {
            if (value_1(matchValue) == null) {
                return cons(undefined, getWidthsForPorts(inputs, portNumbers$0027));
            }
            else {
                const width = value_1(matchValue)[0];
                return cons(width, getWidthsForPorts(inputs, portNumbers$0027));
            }
        }
        else {
            return toFail(printf("what? getWidthForPorts received a not extistent port: %A %A"))(portNumber)(inputs);
        }
    }
    else {
        return empty();
    }
}

function getConnectionIdForPort(inputs, portNumber) {
    const matchValue = FSharpMap__TryFind(inputs, portNumber);
    if (matchValue != null) {
        if (value_1(matchValue) != null) {
            const connId = value_1(matchValue)[1];
            return connId;
        }
        else {
            return toFail(printf("what? getConnectionIdForPort called with an unconnected port: %A %A"))(portNumber)(inputs);
        }
    }
    else {
        return toFail(printf("what? getConnectionIdForPort received a not extistent port: %A %A"))(portNumber)(inputs);
    }
}

function makeWidthInferErrorEqual(expected, actual, connectionsAffected) {
    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wrong wire width. Target port expects a %d-bit signal, but source port produces a %d-bit signal."))(expected)(actual), connectionsAffected)]);
}

function makeWidthInferErrorAtLeast(atLeast, actual, connectionsAffected) {
    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wrong wire width. Target port expects a signal with at least %d bits, but source port produces a %d-bit signal."))(atLeast)(actual), connectionsAffected)]);
}

function makeWidthInferErrorMax(max, actual, connectionsAffected) {
    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wrong wire width. Target port expects a signal with maximum %d bits, but source port produces a %d-bit signal."))(max)(actual), connectionsAffected)]);
}

function makeComponentInconsistentError(msg) {
    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(msg, empty())]);
}

/**
 * Add to the map the extra (virtual) connections formed from each set of similarlky named bus labels.
 * each unconnected bus label input is virtually connected to the (single) connection
 * that drives the set
 */
export function addVirtualBusLabelConnections(compIdToComp, inputPortsToConnectionIds) {
    let source_2;
    const inputPort0Id = (comp) => item(0, comp.InputPorts).Id;
    return ofSeq_1((source_2 = toSeq(inputPortsToConnectionIds), append(ofList(collect((tupledArg) => {
        let option_1;
        const labComps = tupledArg[1];
        return defaultArg((option_1 = tryPick((comp_4) => tryFind_1(inputPort0Id(comp_4), inputPortsToConnectionIds), labComps), (option_1 != null) ? ((connId) => map_2((comp_3) => [inputPort0Id(comp_3), connId], labComps))(option_1) : undefined), empty());
    }, List_groupBy((comp_2) => comp_2.Label, filter((comp_1) => equals(comp_1.Type, ComponentType.IOLabel), mapValues(compIdToComp)), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }))), source_2)), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
}

function makeOutputPortsOfLabels(components) {
    return ofList_1(map_2((tupledArg) => [tupledArg[0], map_2((comp) => getOutputPortId(comp, 0), tupledArg[1])], List_groupBy((c) => c.Label, filter((_arg) => {
        if (_arg.Type.tag === 3) {
            return true;
        }
        else {
            return false;
        }
    }, components), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
}

function calculateOutputPortsWidth(comp, outputPortsOfBusLabels, inputConnectionsWidth) {
    let n_27, b, a, n_28, b_1, a_1, n_30, b_2, a_2, n_32, b_3, a_3, n_45, f, e, d, c, b_6, a_7, n_46, f_1, e_1, d_1, c_1, b_7, a_8, n_48, f_2, e_2, d_2, c_2, b_8, a_9, n_50, f_3, e_3, d_3, c_3, b_9, a_10, write, datain;
    const getConnectionIdForPort_1 = (arg) => getConnectionIdForPort(inputConnectionsWidth, arg);
    const matchValue = comp.Type;
    let matchResult, width, width_1, numberOfBits_4, mem, mem_1;
    switch (matchValue.tag) {
        case 48: {
            matchResult = 1;
            break;
        }
        case 53: {
            matchResult = 4;
            break;
        }
        case 4: {
            matchResult = 5;
            break;
        }
        case 3: {
            matchResult = 6;
            break;
        }
        case 6: {
            matchResult = 7;
            break;
        }
        case 47: {
            matchResult = 8;
            break;
        }
        case 5: {
            matchResult = 9;
            break;
        }
        case 8: {
            matchResult = 10;
            break;
        }
        case 10: {
            matchResult = 11;
            break;
        }
        case 11: {
            matchResult = 12;
            break;
        }
        case 12: {
            matchResult = 13;
            break;
        }
        case 13: {
            matchResult = 14;
            break;
        }
        case 14: {
            matchResult = 15;
            break;
        }
        case 15: {
            matchResult = 16;
            break;
        }
        case 16: {
            matchResult = 17;
            break;
        }
        case 46: {
            matchResult = 18;
            break;
        }
        case 17: {
            matchResult = 19;
            break;
        }
        case 19: {
            matchResult = 20;
            break;
        }
        case 18: {
            matchResult = 21;
            break;
        }
        case 20: {
            matchResult = 22;
            break;
        }
        case 23: {
            matchResult = 24;
            break;
        }
        case 25: {
            matchResult = 25;
            break;
        }
        case 9: {
            matchResult = 26;
            break;
        }
        case 26: {
            matchResult = 27;
            break;
        }
        case 27: {
            matchResult = 28;
            break;
        }
        case 29: {
            matchResult = 29;
            break;
        }
        case 54: {
            matchResult = 30;
            break;
        }
        case 55: {
            matchResult = 31;
            break;
        }
        case 28: {
            matchResult = 32;
            break;
        }
        case 30: {
            matchResult = 33;
            break;
        }
        case 31: {
            matchResult = 34;
            break;
        }
        case 32: {
            matchResult = 35;
            break;
        }
        case 33: {
            matchResult = 36;
            break;
        }
        case 34: {
            matchResult = 37;
            break;
        }
        case 35: {
            matchResult = 38;
            break;
        }
        case 37: {
            matchResult = 39;
            break;
        }
        case 36: {
            matchResult = 40;
            break;
        }
        case 38: {
            matchResult = 41;
            break;
        }
        case 0: {
            matchResult = 2;
            width = matchValue.fields[0];
            break;
        }
        case 7: {
            matchResult = 2;
            width = matchValue.fields[0];
            break;
        }
        case 49: {
            matchResult = 2;
            width = matchValue.fields[0];
            break;
        }
        case 1: {
            matchResult = 3;
            width_1 = matchValue.fields[0];
            break;
        }
        case 2: {
            matchResult = 3;
            width_1 = matchValue.fields[0];
            break;
        }
        case 50: {
            matchResult = 3;
            width_1 = matchValue.fields[0];
            break;
        }
        case 51: {
            matchResult = 3;
            width_1 = matchValue.fields[0];
            break;
        }
        case 52: {
            matchResult = 3;
            width_1 = matchValue.fields[0];
            break;
        }
        case 21: {
            matchResult = 23;
            numberOfBits_4 = matchValue.fields[0];
            break;
        }
        case 22: {
            matchResult = 23;
            numberOfBits_4 = matchValue.fields[0];
            break;
        }
        case 24: {
            matchResult = 23;
            numberOfBits_4 = matchValue.fields[0];
            break;
        }
        case 39: {
            matchResult = 42;
            mem = matchValue.fields[0];
            break;
        }
        case 40: {
            matchResult = 42;
            mem = matchValue.fields[0];
            break;
        }
        case 41: {
            matchResult = 43;
            mem_1 = matchValue.fields[0];
            break;
        }
        case 42: {
            matchResult = 43;
            mem_1 = matchValue.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return toFail(printf("What? Legacy RAM component types should never occur"));
        case 1:
            return toFail(printf("Legacy Input components should never occur"));
        case 2: {
            assertInputsSize(inputConnectionsWidth, 0, comp);
            return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x, y) => (compare(x, y) | 0),
            }), getOutputPortId(comp, 0), width)]);
        }
        case 3: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_1 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_1, n;
            if (!isEmpty(matchValue_1)) {
                if (head(matchValue_1) != null) {
                    if (isEmpty(tail(matchValue_1))) {
                        matchResult_1 = 1;
                        n = head(matchValue_1);
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_1))) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
                    })]);
                case 1:
                    if (n === width_1) {
                        return new FSharpResult$2(/* Ok */ 0, [empty_1({
                            Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
                        })]);
                    }
                    else {
                        return makeWidthInferErrorEqual(width_1, n, singleton(getConnectionIdForPort_1(0)));
                    }
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 4: {
            assertInputsSize(inputConnectionsWidth, 0, comp);
            return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
            }), getOutputPortId(comp, 0), matchValue.fields[0])]);
        }
        case 5: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            return new FSharpResult$2(/* Ok */ 0, [empty_1({
                Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
            })]);
        }
        case 6: {
            const matchValue_2 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_2, n_1;
            if (!isEmpty(matchValue_2)) {
                if (head(matchValue_2) != null) {
                    if (isEmpty(tail(matchValue_2))) {
                        matchResult_2 = 1;
                        n_1 = head(matchValue_2);
                    }
                    else {
                        matchResult_2 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_2))) {
                    matchResult_2 = 0;
                }
                else {
                    matchResult_2 = 2;
                }
            }
            else {
                matchResult_2 = 2;
            }
            switch (matchResult_2) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
                    })]);
                case 1:
                    return new FSharpResult$2(/* Ok */ 0, [ofList_1(map_2((out) => [out, n_1], FSharpMap__get_Item(outputPortsOfBusLabels, comp.Label)), {
                        Compare: (x_6, y_6) => (compare(x_6, y_6) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 7: {
            const width_3 = matchValue.fields[0] | 0;
            const lsBitNum = matchValue.fields[1] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_3 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_3, n_3;
            if (!isEmpty(matchValue_3)) {
                if (head(matchValue_3) == null) {
                    if (isEmpty(tail(matchValue_3))) {
                        matchResult_3 = 1;
                    }
                    else {
                        matchResult_3 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_3))) {
                    if (head(matchValue_3) < (width_3 + lsBitNum)) {
                        matchResult_3 = 0;
                        n_3 = head(matchValue_3);
                    }
                    else {
                        matchResult_3 = 1;
                    }
                }
                else {
                    matchResult_3 = 2;
                }
            }
            else {
                matchResult_3 = 2;
            }
            switch (matchResult_3) {
                case 0:
                    return makeWidthInferErrorAtLeast(lsBitNum + n_3, n_3, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_7, y_7) => (compare(x_7, y_7) | 0),
                    }), getOutputPortId(comp, 0), width_3)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 8: {
            const width_4 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_4 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_4, n_5;
            if (!isEmpty(matchValue_4)) {
                if (head(matchValue_4) == null) {
                    if (isEmpty(tail(matchValue_4))) {
                        matchResult_4 = 1;
                    }
                    else {
                        matchResult_4 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_4))) {
                    if (head(matchValue_4) !== width_4) {
                        matchResult_4 = 0;
                        n_5 = head(matchValue_4);
                    }
                    else {
                        matchResult_4 = 1;
                    }
                }
                else {
                    matchResult_4 = 2;
                }
            }
            else {
                matchResult_4 = 2;
            }
            switch (matchResult_4) {
                case 0:
                    return makeWidthInferErrorEqual(width_4, n_5, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_8, y_8) => (compare(x_8, y_8) | 0),
                    }), getOutputPortId(comp, 0), 1)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 9: {
            const width_5 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_5 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_5, n_7;
            if (!isEmpty(matchValue_5)) {
                if (head(matchValue_5) == null) {
                    if (isEmpty(tail(matchValue_5))) {
                        matchResult_5 = 1;
                    }
                    else {
                        matchResult_5 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_5))) {
                    if (head(matchValue_5) !== width_5) {
                        matchResult_5 = 0;
                        n_7 = head(matchValue_5);
                    }
                    else {
                        matchResult_5 = 1;
                    }
                }
                else {
                    matchResult_5 = 2;
                }
            }
            else {
                matchResult_5 = 2;
            }
            switch (matchResult_5) {
                case 0:
                    return makeWidthInferErrorEqual(width_5, n_7, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_9, y_9) => (compare(x_9, y_9) | 0),
                    }), getOutputPortId(comp, 0), 1)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 10: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_6 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_6, n_8;
            if (!isEmpty(matchValue_6)) {
                if (head(matchValue_6) != null) {
                    if (head(matchValue_6) === 1) {
                        if (isEmpty(tail(matchValue_6))) {
                            matchResult_6 = 0;
                        }
                        else {
                            matchResult_6 = 2;
                        }
                    }
                    else if (isEmpty(tail(matchValue_6))) {
                        matchResult_6 = 1;
                        n_8 = head(matchValue_6);
                    }
                    else {
                        matchResult_6 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_6))) {
                    matchResult_6 = 0;
                }
                else {
                    matchResult_6 = 2;
                }
            }
            else {
                matchResult_6 = 2;
            }
            switch (matchResult_6) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_10, y_10) => (compare(x_10, y_10) | 0),
                    }), getOutputPortId(comp, 0), 1)]);
                case 1:
                    return makeWidthInferErrorEqual(1, n_8, singleton(getConnectionIdForPort_1(0)));
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 11: {
            const n_9 = matchValue.fields[1] | 0;
            assertInputsSize(inputConnectionsWidth, n_9, comp);
            const portWidths = getWidthsForPorts(inputConnectionsWidth, initialize(n_9, (i) => (i | 0)));
            const _arg_1 = tryFindIndex((_arg) => {
                if (_arg == null) {
                    return false;
                }
                else {
                    return _arg !== 1;
                }
            }, portWidths);
            if (_arg_1 == null) {
                return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                    Compare: (x_11, y_11) => (compare(x_11, y_11) | 0),
                }), getOutputPortId(comp, 0), 1)]);
            }
            else {
                const idx = _arg_1 | 0;
                return makeWidthInferErrorEqual(1, value_1(item(idx, portWidths)), singleton(getConnectionIdForPort_1(idx)));
            }
        }
        case 12: {
            assertInputsSize(inputConnectionsWidth, 3, comp);
            const matchValue_7 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2]));
            let matchResult_7, m_4, n_19, m_5, n_20, n_21, n_22;
            if (!isEmpty(matchValue_7)) {
                if (head(matchValue_7) == null) {
                    if (!isEmpty(tail(matchValue_7))) {
                        if (!isEmpty(tail(tail(matchValue_7)))) {
                            if (head(tail(tail(matchValue_7))) != null) {
                                if (isEmpty(tail(tail(tail(matchValue_7))))) {
                                    if (head(tail(tail(matchValue_7))) !== 1) {
                                        matchResult_7 = 2;
                                        n_21 = head(tail(tail(matchValue_7)));
                                    }
                                    else if (head(tail(matchValue_7)) != null) {
                                        matchResult_7 = 3;
                                        n_22 = head(tail(matchValue_7));
                                    }
                                    else {
                                        matchResult_7 = 4;
                                    }
                                }
                                else {
                                    matchResult_7 = 5;
                                }
                            }
                            else if (isEmpty(tail(tail(tail(matchValue_7))))) {
                                if (head(tail(matchValue_7)) != null) {
                                    matchResult_7 = 3;
                                    n_22 = head(tail(matchValue_7));
                                }
                                else {
                                    matchResult_7 = 4;
                                }
                            }
                            else {
                                matchResult_7 = 5;
                            }
                        }
                        else {
                            matchResult_7 = 5;
                        }
                    }
                    else {
                        matchResult_7 = 5;
                    }
                }
                else if (!isEmpty(tail(matchValue_7))) {
                    if (head(tail(matchValue_7)) == null) {
                        if (!isEmpty(tail(tail(matchValue_7)))) {
                            if (head(tail(tail(matchValue_7))) != null) {
                                if (isEmpty(tail(tail(tail(matchValue_7))))) {
                                    if (head(tail(tail(matchValue_7))) !== 1) {
                                        matchResult_7 = 2;
                                        n_21 = head(tail(tail(matchValue_7)));
                                    }
                                    else {
                                        matchResult_7 = 3;
                                        n_22 = head(matchValue_7);
                                    }
                                }
                                else {
                                    matchResult_7 = 5;
                                }
                            }
                            else if (isEmpty(tail(tail(tail(matchValue_7))))) {
                                matchResult_7 = 3;
                                n_22 = head(matchValue_7);
                            }
                            else {
                                matchResult_7 = 5;
                            }
                        }
                        else {
                            matchResult_7 = 5;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_7)))) {
                        if (head(tail(tail(matchValue_7))) != null) {
                            if (head(tail(tail(matchValue_7))) === 1) {
                                if (isEmpty(tail(tail(tail(matchValue_7))))) {
                                    if (head(matchValue_7) === head(tail(matchValue_7))) {
                                        matchResult_7 = 0;
                                        m_4 = head(tail(matchValue_7));
                                        n_19 = head(matchValue_7);
                                    }
                                    else if (head(matchValue_7) !== head(tail(matchValue_7))) {
                                        matchResult_7 = 1;
                                        m_5 = head(tail(matchValue_7));
                                        n_20 = head(matchValue_7);
                                    }
                                    else if (head(tail(tail(matchValue_7))) !== 1) {
                                        matchResult_7 = 2;
                                        n_21 = head(tail(tail(matchValue_7)));
                                    }
                                    else {
                                        matchResult_7 = 4;
                                    }
                                }
                                else {
                                    matchResult_7 = 5;
                                }
                            }
                            else if (isEmpty(tail(tail(tail(matchValue_7))))) {
                                if (head(matchValue_7) !== head(tail(matchValue_7))) {
                                    matchResult_7 = 1;
                                    m_5 = head(tail(matchValue_7));
                                    n_20 = head(matchValue_7);
                                }
                                else if (head(tail(tail(matchValue_7))) !== 1) {
                                    matchResult_7 = 2;
                                    n_21 = head(tail(tail(matchValue_7)));
                                }
                                else {
                                    matchResult_7 = 4;
                                }
                            }
                            else {
                                matchResult_7 = 5;
                            }
                        }
                        else if (isEmpty(tail(tail(tail(matchValue_7))))) {
                            if (head(matchValue_7) !== head(tail(matchValue_7))) {
                                matchResult_7 = 1;
                                m_5 = head(tail(matchValue_7));
                                n_20 = head(matchValue_7);
                            }
                            else {
                                matchResult_7 = 4;
                            }
                        }
                        else {
                            matchResult_7 = 5;
                        }
                    }
                    else {
                        matchResult_7 = 5;
                    }
                }
                else {
                    matchResult_7 = 5;
                }
            }
            else {
                matchResult_7 = 5;
            }
            switch (matchResult_7) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_12, y_12) => (compare(x_12, y_12) | 0),
                    }), getOutputPortId(comp, 0), n_19)]);
                case 1:
                    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wrong wire width. The two inputs to a multiplexer are expected to have the same width, but top input has %d bits and bottom input has %d bits."))(n_20)(m_5), ofArray([getConnectionIdForPort_1(0), getConnectionIdForPort_1(1)]))]);
                case 2:
                    return makeWidthInferErrorEqual(1, n_21, singleton(getConnectionIdForPort_1(2)));
                case 3:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_13, y_13) => (compare(x_13, y_13) | 0),
                    }), getOutputPortId(comp, 0), n_22)]);
                case 4:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_14, y_14) => (compare(x_14, y_14) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 13: {
            assertInputsSize(inputConnectionsWidth, 5, comp);
            const matchValue_8 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2, 3, 4]));
            let matchResult_8, a_4, b_4, m_10, n_33, a_5, b_5, m_11, n_34, n_35, a_6, m_12, n_36;
            if (!isEmpty(matchValue_8)) {
                if (head(matchValue_8) == null) {
                    if (!isEmpty(tail(matchValue_8))) {
                        if (!isEmpty(tail(tail(matchValue_8)))) {
                            if (!isEmpty(tail(tail(tail(matchValue_8))))) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_8)))))) {
                                    if (head(tail(tail(tail(tail(matchValue_8))))) != null) {
                                        if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                            if (head(tail(tail(tail(tail(matchValue_8))))) !== 2) {
                                                matchResult_8 = 2;
                                                n_35 = head(tail(tail(tail(tail(matchValue_8)))));
                                            }
                                            else if (head(tail(tail(tail(matchValue_8)))) != null) {
                                                if (head(tail(tail(matchValue_8))) != null) {
                                                    if (head(tail(matchValue_8)) != null) {
                                                        matchResult_8 = 3;
                                                        a_6 = head(tail(tail(tail(matchValue_8))));
                                                        m_12 = head(tail(tail(matchValue_8)));
                                                        n_36 = head(tail(matchValue_8));
                                                    }
                                                    else {
                                                        matchResult_8 = 4;
                                                    }
                                                }
                                                else {
                                                    matchResult_8 = 4;
                                                }
                                            }
                                            else {
                                                matchResult_8 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_8 = 5;
                                        }
                                    }
                                    else if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                        if (head(tail(tail(tail(matchValue_8)))) != null) {
                                            if (head(tail(tail(matchValue_8))) != null) {
                                                if (head(tail(matchValue_8)) != null) {
                                                    matchResult_8 = 3;
                                                    a_6 = head(tail(tail(tail(matchValue_8))));
                                                    m_12 = head(tail(tail(matchValue_8)));
                                                    n_36 = head(tail(matchValue_8));
                                                }
                                                else {
                                                    matchResult_8 = 4;
                                                }
                                            }
                                            else {
                                                matchResult_8 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_8 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_8 = 5;
                                    }
                                }
                                else {
                                    matchResult_8 = 5;
                                }
                            }
                            else {
                                matchResult_8 = 5;
                            }
                        }
                        else {
                            matchResult_8 = 5;
                        }
                    }
                    else {
                        matchResult_8 = 5;
                    }
                }
                else if (!isEmpty(tail(matchValue_8))) {
                    if (head(tail(matchValue_8)) == null) {
                        if (!isEmpty(tail(tail(matchValue_8)))) {
                            if (!isEmpty(tail(tail(tail(matchValue_8))))) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_8)))))) {
                                    if (head(tail(tail(tail(tail(matchValue_8))))) != null) {
                                        if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                            if (head(tail(tail(tail(tail(matchValue_8))))) !== 2) {
                                                matchResult_8 = 2;
                                                n_35 = head(tail(tail(tail(tail(matchValue_8)))));
                                            }
                                            else if (head(tail(tail(tail(matchValue_8)))) != null) {
                                                if (head(tail(tail(matchValue_8))) != null) {
                                                    matchResult_8 = 3;
                                                    a_6 = head(tail(tail(tail(matchValue_8))));
                                                    m_12 = head(tail(tail(matchValue_8)));
                                                    n_36 = head(matchValue_8);
                                                }
                                                else {
                                                    matchResult_8 = 4;
                                                }
                                            }
                                            else {
                                                matchResult_8 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_8 = 5;
                                        }
                                    }
                                    else if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                        if (head(tail(tail(tail(matchValue_8)))) != null) {
                                            if (head(tail(tail(matchValue_8))) != null) {
                                                matchResult_8 = 3;
                                                a_6 = head(tail(tail(tail(matchValue_8))));
                                                m_12 = head(tail(tail(matchValue_8)));
                                                n_36 = head(matchValue_8);
                                            }
                                            else {
                                                matchResult_8 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_8 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_8 = 5;
                                    }
                                }
                                else {
                                    matchResult_8 = 5;
                                }
                            }
                            else {
                                matchResult_8 = 5;
                            }
                        }
                        else {
                            matchResult_8 = 5;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_8)))) {
                        if (head(tail(tail(matchValue_8))) == null) {
                            if (!isEmpty(tail(tail(tail(matchValue_8))))) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_8)))))) {
                                    if (head(tail(tail(tail(tail(matchValue_8))))) != null) {
                                        if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                            if (head(tail(tail(tail(tail(matchValue_8))))) !== 2) {
                                                matchResult_8 = 2;
                                                n_35 = head(tail(tail(tail(tail(matchValue_8)))));
                                            }
                                            else if (head(tail(tail(tail(matchValue_8)))) != null) {
                                                matchResult_8 = 3;
                                                a_6 = head(tail(tail(tail(matchValue_8))));
                                                m_12 = head(tail(matchValue_8));
                                                n_36 = head(matchValue_8);
                                            }
                                            else {
                                                matchResult_8 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_8 = 5;
                                        }
                                    }
                                    else if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                        if (head(tail(tail(tail(matchValue_8)))) != null) {
                                            matchResult_8 = 3;
                                            a_6 = head(tail(tail(tail(matchValue_8))));
                                            m_12 = head(tail(matchValue_8));
                                            n_36 = head(matchValue_8);
                                        }
                                        else {
                                            matchResult_8 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_8 = 5;
                                    }
                                }
                                else {
                                    matchResult_8 = 5;
                                }
                            }
                            else {
                                matchResult_8 = 5;
                            }
                        }
                        else if (!isEmpty(tail(tail(tail(matchValue_8))))) {
                            if (head(tail(tail(tail(matchValue_8)))) == null) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_8)))))) {
                                    if (head(tail(tail(tail(tail(matchValue_8))))) != null) {
                                        if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                            if (head(tail(tail(tail(tail(matchValue_8))))) !== 2) {
                                                matchResult_8 = 2;
                                                n_35 = head(tail(tail(tail(tail(matchValue_8)))));
                                            }
                                            else {
                                                matchResult_8 = 3;
                                                a_6 = head(tail(tail(matchValue_8)));
                                                m_12 = head(tail(matchValue_8));
                                                n_36 = head(matchValue_8);
                                            }
                                        }
                                        else {
                                            matchResult_8 = 5;
                                        }
                                    }
                                    else if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                        matchResult_8 = 3;
                                        a_6 = head(tail(tail(matchValue_8)));
                                        m_12 = head(tail(matchValue_8));
                                        n_36 = head(matchValue_8);
                                    }
                                    else {
                                        matchResult_8 = 5;
                                    }
                                }
                                else {
                                    matchResult_8 = 5;
                                }
                            }
                            else if (!isEmpty(tail(tail(tail(tail(matchValue_8)))))) {
                                if (head(tail(tail(tail(tail(matchValue_8))))) != null) {
                                    if (head(tail(tail(tail(tail(matchValue_8))))) === 2) {
                                        if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                            if ((n_27 = (head(matchValue_8) | 0), (b = (head(tail(tail(tail(matchValue_8)))) | 0), (a = (head(tail(tail(matchValue_8))) | 0), ((n_27 === head(tail(matchValue_8))) && (n_27 === a)) && (n_27 === b))))) {
                                                matchResult_8 = 0;
                                                a_4 = head(tail(tail(matchValue_8)));
                                                b_4 = head(tail(tail(tail(matchValue_8))));
                                                m_10 = head(tail(matchValue_8));
                                                n_33 = head(matchValue_8);
                                            }
                                            else if ((n_28 = (head(matchValue_8) | 0), (b_1 = (head(tail(tail(tail(matchValue_8)))) | 0), (a_1 = (head(tail(tail(matchValue_8))) | 0), ((n_28 !== head(tail(matchValue_8))) ? true : (n_28 !== a_1)) ? true : (n_28 !== b_1))))) {
                                                matchResult_8 = 1;
                                                a_5 = head(tail(tail(matchValue_8)));
                                                b_5 = head(tail(tail(tail(matchValue_8))));
                                                m_11 = head(tail(matchValue_8));
                                                n_34 = head(matchValue_8);
                                            }
                                            else if (head(tail(tail(tail(tail(matchValue_8))))) !== 2) {
                                                matchResult_8 = 2;
                                                n_35 = head(tail(tail(tail(tail(matchValue_8)))));
                                            }
                                            else {
                                                matchResult_8 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_8 = 5;
                                        }
                                    }
                                    else if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                        if ((n_30 = (head(matchValue_8) | 0), (b_2 = (head(tail(tail(tail(matchValue_8)))) | 0), (a_2 = (head(tail(tail(matchValue_8))) | 0), ((n_30 !== head(tail(matchValue_8))) ? true : (n_30 !== a_2)) ? true : (n_30 !== b_2))))) {
                                            matchResult_8 = 1;
                                            a_5 = head(tail(tail(matchValue_8)));
                                            b_5 = head(tail(tail(tail(matchValue_8))));
                                            m_11 = head(tail(matchValue_8));
                                            n_34 = head(matchValue_8);
                                        }
                                        else if (head(tail(tail(tail(tail(matchValue_8))))) !== 2) {
                                            matchResult_8 = 2;
                                            n_35 = head(tail(tail(tail(tail(matchValue_8)))));
                                        }
                                        else {
                                            matchResult_8 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_8 = 5;
                                    }
                                }
                                else if (isEmpty(tail(tail(tail(tail(tail(matchValue_8))))))) {
                                    if ((n_32 = (head(matchValue_8) | 0), (b_3 = (head(tail(tail(tail(matchValue_8)))) | 0), (a_3 = (head(tail(tail(matchValue_8))) | 0), ((n_32 !== head(tail(matchValue_8))) ? true : (n_32 !== a_3)) ? true : (n_32 !== b_3))))) {
                                        matchResult_8 = 1;
                                        a_5 = head(tail(tail(matchValue_8)));
                                        b_5 = head(tail(tail(tail(matchValue_8))));
                                        m_11 = head(tail(matchValue_8));
                                        n_34 = head(matchValue_8);
                                    }
                                    else {
                                        matchResult_8 = 4;
                                    }
                                }
                                else {
                                    matchResult_8 = 5;
                                }
                            }
                            else {
                                matchResult_8 = 5;
                            }
                        }
                        else {
                            matchResult_8 = 5;
                        }
                    }
                    else {
                        matchResult_8 = 5;
                    }
                }
                else {
                    matchResult_8 = 5;
                }
            }
            else {
                matchResult_8 = 5;
            }
            switch (matchResult_8) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_15, y_15) => (compare(x_15, y_15) | 0),
                    }), getOutputPortId(comp, 0), n_33)]);
                case 1:
                    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wrong wire width. The four inputs to a multiplexer are expected to have the same width, but 1st input has %d bits, 2nd input has %d bits, 3rd input has %d bits, 4th input has %d bits."))(n_34)(m_11)(a_5)(b_5), ofArray([getConnectionIdForPort_1(0), getConnectionIdForPort_1(1), getConnectionIdForPort_1(2), getConnectionIdForPort_1(3)]))]);
                case 2:
                    return makeWidthInferErrorEqual(2, n_35, singleton(getConnectionIdForPort_1(4)));
                case 3:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_16, y_16) => (compare(x_16, y_16) | 0),
                    }), getOutputPortId(comp, 0), n_36)]);
                case 4:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_17, y_17) => (compare(x_17, y_17) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 14: {
            assertInputsSize(inputConnectionsWidth, 9, comp);
            const matchValue_9 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2, 3, 4, 5, 6, 7, 8]));
            let matchResult_9, a_11, b_10, c_4, d_4, e_4, f_4, m_17, n_51, a_12, b_11, c_5, d_5, e_5, f_5, m_18, n_52, n_53, a_13, b_12, c_6, d_6, e_6, m_19, n_54;
            if (!isEmpty(matchValue_9)) {
                if (head(matchValue_9) == null) {
                    if (!isEmpty(tail(matchValue_9))) {
                        if (!isEmpty(tail(tail(matchValue_9)))) {
                            if (!isEmpty(tail(tail(tail(matchValue_9))))) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_9)))))) {
                                    if (!isEmpty(tail(tail(tail(tail(tail(matchValue_9))))))) {
                                        if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                    if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                        if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                            if (head(tail(tail(tail(matchValue_9)))) != null) {
                                                                                if (head(tail(tail(matchValue_9))) != null) {
                                                                                    if (head(tail(matchValue_9)) != null) {
                                                                                        matchResult_9 = 3;
                                                                                        a_13 = head(tail(tail(tail(matchValue_9))));
                                                                                        b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                                        c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                                        d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                                        e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                                        m_19 = head(tail(tail(matchValue_9)));
                                                                                        n_54 = head(tail(matchValue_9));
                                                                                    }
                                                                                    else {
                                                                                        matchResult_9 = 4;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    matchResult_9 = 4;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_9 = 4;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                    if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                        if (head(tail(tail(tail(matchValue_9)))) != null) {
                                                                            if (head(tail(tail(matchValue_9))) != null) {
                                                                                if (head(tail(matchValue_9)) != null) {
                                                                                    matchResult_9 = 3;
                                                                                    a_13 = head(tail(tail(tail(matchValue_9))));
                                                                                    b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                                    c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                                    d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                                    e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                                    m_19 = head(tail(tail(matchValue_9)));
                                                                                    n_54 = head(tail(matchValue_9));
                                                                                }
                                                                                else {
                                                                                    matchResult_9 = 4;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_9 = 4;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else {
                                        matchResult_9 = 5;
                                    }
                                }
                                else {
                                    matchResult_9 = 5;
                                }
                            }
                            else {
                                matchResult_9 = 5;
                            }
                        }
                        else {
                            matchResult_9 = 5;
                        }
                    }
                    else {
                        matchResult_9 = 5;
                    }
                }
                else if (!isEmpty(tail(matchValue_9))) {
                    if (head(tail(matchValue_9)) == null) {
                        if (!isEmpty(tail(tail(matchValue_9)))) {
                            if (!isEmpty(tail(tail(tail(matchValue_9))))) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_9)))))) {
                                    if (!isEmpty(tail(tail(tail(tail(tail(matchValue_9))))))) {
                                        if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                    if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                        if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                            if (head(tail(tail(tail(matchValue_9)))) != null) {
                                                                                if (head(tail(tail(matchValue_9))) != null) {
                                                                                    matchResult_9 = 3;
                                                                                    a_13 = head(tail(tail(tail(matchValue_9))));
                                                                                    b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                                    c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                                    d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                                    e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                                    m_19 = head(tail(tail(matchValue_9)));
                                                                                    n_54 = head(matchValue_9);
                                                                                }
                                                                                else {
                                                                                    matchResult_9 = 4;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_9 = 4;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                    if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                        if (head(tail(tail(tail(matchValue_9)))) != null) {
                                                                            if (head(tail(tail(matchValue_9))) != null) {
                                                                                matchResult_9 = 3;
                                                                                a_13 = head(tail(tail(tail(matchValue_9))));
                                                                                b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                                c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                                d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                                e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                                m_19 = head(tail(tail(matchValue_9)));
                                                                                n_54 = head(matchValue_9);
                                                                            }
                                                                            else {
                                                                                matchResult_9 = 4;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else {
                                        matchResult_9 = 5;
                                    }
                                }
                                else {
                                    matchResult_9 = 5;
                                }
                            }
                            else {
                                matchResult_9 = 5;
                            }
                        }
                        else {
                            matchResult_9 = 5;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_9)))) {
                        if (head(tail(tail(matchValue_9))) == null) {
                            if (!isEmpty(tail(tail(tail(matchValue_9))))) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_9)))))) {
                                    if (!isEmpty(tail(tail(tail(tail(tail(matchValue_9))))))) {
                                        if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                    if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                        if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                            if (head(tail(tail(tail(matchValue_9)))) != null) {
                                                                                matchResult_9 = 3;
                                                                                a_13 = head(tail(tail(tail(matchValue_9))));
                                                                                b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                                c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                                d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                                e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                                m_19 = head(tail(matchValue_9));
                                                                                n_54 = head(matchValue_9);
                                                                            }
                                                                            else {
                                                                                matchResult_9 = 4;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                    if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                        if (head(tail(tail(tail(matchValue_9)))) != null) {
                                                                            matchResult_9 = 3;
                                                                            a_13 = head(tail(tail(tail(matchValue_9))));
                                                                            b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                            c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                            d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                            e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                            m_19 = head(tail(matchValue_9));
                                                                            n_54 = head(matchValue_9);
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else {
                                        matchResult_9 = 5;
                                    }
                                }
                                else {
                                    matchResult_9 = 5;
                                }
                            }
                            else {
                                matchResult_9 = 5;
                            }
                        }
                        else if (!isEmpty(tail(tail(tail(matchValue_9))))) {
                            if (head(tail(tail(tail(matchValue_9)))) == null) {
                                if (!isEmpty(tail(tail(tail(tail(matchValue_9)))))) {
                                    if (!isEmpty(tail(tail(tail(tail(tail(matchValue_9))))))) {
                                        if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                    if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                        if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                            matchResult_9 = 3;
                                                                            a_13 = head(tail(tail(matchValue_9)));
                                                                            b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                            c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                            d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                            e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                            m_19 = head(tail(matchValue_9));
                                                                            n_54 = head(matchValue_9);
                                                                        }
                                                                        else {
                                                                            matchResult_9 = 4;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                    if (head(tail(tail(tail(tail(matchValue_9))))) != null) {
                                                                        matchResult_9 = 3;
                                                                        a_13 = head(tail(tail(matchValue_9)));
                                                                        b_12 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                        c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                        d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                        e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                        m_19 = head(tail(matchValue_9));
                                                                        n_54 = head(matchValue_9);
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else {
                                        matchResult_9 = 5;
                                    }
                                }
                                else {
                                    matchResult_9 = 5;
                                }
                            }
                            else if (!isEmpty(tail(tail(tail(tail(matchValue_9)))))) {
                                if (head(tail(tail(tail(tail(matchValue_9))))) == null) {
                                    if (!isEmpty(tail(tail(tail(tail(tail(matchValue_9))))))) {
                                        if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                    if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                        matchResult_9 = 3;
                                                                        a_13 = head(tail(tail(matchValue_9)));
                                                                        b_12 = head(tail(tail(tail(matchValue_9))));
                                                                        c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                        d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                        e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                        m_19 = head(tail(matchValue_9));
                                                                        n_54 = head(matchValue_9);
                                                                    }
                                                                    else {
                                                                        matchResult_9 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(matchValue_9)))))) != null) {
                                                                    matchResult_9 = 3;
                                                                    a_13 = head(tail(tail(matchValue_9)));
                                                                    b_12 = head(tail(tail(tail(matchValue_9))));
                                                                    c_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                    d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                    e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                    m_19 = head(tail(matchValue_9));
                                                                    n_54 = head(matchValue_9);
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else {
                                        matchResult_9 = 5;
                                    }
                                }
                                else if (!isEmpty(tail(tail(tail(tail(tail(matchValue_9))))))) {
                                    if (head(tail(tail(tail(tail(tail(matchValue_9)))))) == null) {
                                        if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                    matchResult_9 = 3;
                                                                    a_13 = head(tail(tail(matchValue_9)));
                                                                    b_12 = head(tail(tail(tail(matchValue_9))));
                                                                    c_6 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                    d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                    e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                    m_19 = head(tail(matchValue_9));
                                                                    n_54 = head(matchValue_9);
                                                                }
                                                                else {
                                                                    matchResult_9 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) != null) {
                                                                matchResult_9 = 3;
                                                                a_13 = head(tail(tail(matchValue_9)));
                                                                b_12 = head(tail(tail(tail(matchValue_9))));
                                                                c_6 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                d_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                m_19 = head(tail(matchValue_9));
                                                                n_54 = head(matchValue_9);
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else if (!isEmpty(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) {
                                        if (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) == null) {
                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                                matchResult_9 = 3;
                                                                a_13 = head(tail(tail(matchValue_9)));
                                                                b_12 = head(tail(tail(tail(matchValue_9))));
                                                                c_6 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                d_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                m_19 = head(tail(matchValue_9));
                                                                n_54 = head(matchValue_9);
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) != null) {
                                                            matchResult_9 = 3;
                                                            a_13 = head(tail(tail(matchValue_9)));
                                                            b_12 = head(tail(tail(tail(matchValue_9))));
                                                            c_6 = head(tail(tail(tail(tail(matchValue_9)))));
                                                            d_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                            e_6 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                            m_19 = head(tail(matchValue_9));
                                                            n_54 = head(matchValue_9);
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) {
                                            if (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) == null) {
                                                if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else {
                                                                matchResult_9 = 3;
                                                                a_13 = head(tail(tail(matchValue_9)));
                                                                b_12 = head(tail(tail(tail(matchValue_9))));
                                                                c_6 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                d_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                e_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                m_19 = head(tail(matchValue_9));
                                                                n_54 = head(matchValue_9);
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        matchResult_9 = 3;
                                                        a_13 = head(tail(tail(matchValue_9)));
                                                        b_12 = head(tail(tail(tail(matchValue_9))));
                                                        c_6 = head(tail(tail(tail(tail(matchValue_9)))));
                                                        d_6 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                        e_6 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                        m_19 = head(tail(matchValue_9));
                                                        n_54 = head(matchValue_9);
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))))) {
                                                if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) != null) {
                                                    if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) === 3) {
                                                        if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                            if ((n_45 = (head(matchValue_9) | 0), (f = (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) | 0), (e = (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) | 0), (d = (head(tail(tail(tail(tail(tail(matchValue_9)))))) | 0), (c = (head(tail(tail(tail(tail(matchValue_9))))) | 0), (b_6 = (head(tail(tail(tail(matchValue_9)))) | 0), (a_7 = (head(tail(tail(matchValue_9))) | 0), ((((((n_45 === head(tail(matchValue_9))) && (n_45 === a_7)) && (n_45 === b_6)) && (n_45 === c)) && (n_45 === d)) && (n_45 === e)) && (n_45 === f))))))))) {
                                                                matchResult_9 = 0;
                                                                a_11 = head(tail(tail(matchValue_9)));
                                                                b_10 = head(tail(tail(tail(matchValue_9))));
                                                                c_4 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                d_4 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                e_4 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                f_4 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                m_17 = head(tail(matchValue_9));
                                                                n_51 = head(matchValue_9);
                                                            }
                                                            else if ((n_46 = (head(matchValue_9) | 0), (f_1 = (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) | 0), (e_1 = (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) | 0), (d_1 = (head(tail(tail(tail(tail(tail(matchValue_9)))))) | 0), (c_1 = (head(tail(tail(tail(tail(matchValue_9))))) | 0), (b_7 = (head(tail(tail(tail(matchValue_9)))) | 0), (a_8 = (head(tail(tail(matchValue_9))) | 0), ((((((n_46 !== head(tail(matchValue_9))) ? true : (n_46 !== a_8)) ? true : (n_46 !== b_7)) ? true : (n_46 !== c_1)) ? true : (n_46 !== d_1)) ? true : (n_46 !== e_1)) ? true : (n_46 !== f_1))))))))) {
                                                                matchResult_9 = 1;
                                                                a_12 = head(tail(tail(matchValue_9)));
                                                                b_11 = head(tail(tail(tail(matchValue_9))));
                                                                c_5 = head(tail(tail(tail(tail(matchValue_9)))));
                                                                d_5 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                                e_5 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                                f_5 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                                m_18 = head(tail(matchValue_9));
                                                                n_52 = head(matchValue_9);
                                                            }
                                                            else if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                                matchResult_9 = 2;
                                                                n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                            }
                                                            else {
                                                                matchResult_9 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_9 = 5;
                                                        }
                                                    }
                                                    else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                        if ((n_48 = (head(matchValue_9) | 0), (f_2 = (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) | 0), (e_2 = (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) | 0), (d_2 = (head(tail(tail(tail(tail(tail(matchValue_9)))))) | 0), (c_2 = (head(tail(tail(tail(tail(matchValue_9))))) | 0), (b_8 = (head(tail(tail(tail(matchValue_9)))) | 0), (a_9 = (head(tail(tail(matchValue_9))) | 0), ((((((n_48 !== head(tail(matchValue_9))) ? true : (n_48 !== a_9)) ? true : (n_48 !== b_8)) ? true : (n_48 !== c_2)) ? true : (n_48 !== d_2)) ? true : (n_48 !== e_2)) ? true : (n_48 !== f_2))))))))) {
                                                            matchResult_9 = 1;
                                                            a_12 = head(tail(tail(matchValue_9)));
                                                            b_11 = head(tail(tail(tail(matchValue_9))));
                                                            c_5 = head(tail(tail(tail(tail(matchValue_9)))));
                                                            d_5 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                            e_5 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                            f_5 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                            m_18 = head(tail(matchValue_9));
                                                            n_52 = head(matchValue_9);
                                                        }
                                                        else if (head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))) !== 3) {
                                                            matchResult_9 = 2;
                                                            n_53 = head(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))));
                                                        }
                                                        else {
                                                            matchResult_9 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_9 = 5;
                                                    }
                                                }
                                                else if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))))))) {
                                                    if ((n_50 = (head(matchValue_9) | 0), (f_3 = (head(tail(tail(tail(tail(tail(tail(tail(matchValue_9)))))))) | 0), (e_3 = (head(tail(tail(tail(tail(tail(tail(matchValue_9))))))) | 0), (d_3 = (head(tail(tail(tail(tail(tail(matchValue_9)))))) | 0), (c_3 = (head(tail(tail(tail(tail(matchValue_9))))) | 0), (b_9 = (head(tail(tail(tail(matchValue_9)))) | 0), (a_10 = (head(tail(tail(matchValue_9))) | 0), ((((((n_50 !== head(tail(matchValue_9))) ? true : (n_50 !== a_10)) ? true : (n_50 !== b_9)) ? true : (n_50 !== c_3)) ? true : (n_50 !== d_3)) ? true : (n_50 !== e_3)) ? true : (n_50 !== f_3))))))))) {
                                                        matchResult_9 = 1;
                                                        a_12 = head(tail(tail(matchValue_9)));
                                                        b_11 = head(tail(tail(tail(matchValue_9))));
                                                        c_5 = head(tail(tail(tail(tail(matchValue_9)))));
                                                        d_5 = head(tail(tail(tail(tail(tail(matchValue_9))))));
                                                        e_5 = head(tail(tail(tail(tail(tail(tail(matchValue_9)))))));
                                                        f_5 = head(tail(tail(tail(tail(tail(tail(tail(matchValue_9))))))));
                                                        m_18 = head(tail(matchValue_9));
                                                        n_52 = head(matchValue_9);
                                                    }
                                                    else {
                                                        matchResult_9 = 4;
                                                    }
                                                }
                                                else {
                                                    matchResult_9 = 5;
                                                }
                                            }
                                            else {
                                                matchResult_9 = 5;
                                            }
                                        }
                                        else {
                                            matchResult_9 = 5;
                                        }
                                    }
                                    else {
                                        matchResult_9 = 5;
                                    }
                                }
                                else {
                                    matchResult_9 = 5;
                                }
                            }
                            else {
                                matchResult_9 = 5;
                            }
                        }
                        else {
                            matchResult_9 = 5;
                        }
                    }
                    else {
                        matchResult_9 = 5;
                    }
                }
                else {
                    matchResult_9 = 5;
                }
            }
            else {
                matchResult_9 = 5;
            }
            switch (matchResult_9) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_18, y_18) => (compare(x_18, y_18) | 0),
                    }), getOutputPortId(comp, 0), n_51)]);
                case 1:
                    return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wrong wire width. The eight inputs to a multiplexer are expected to have the same width, but 1st input has %d bits, 2nd input has %d bits, 3rd input has %d bits, 4th input has %d bits, 5th input has %d bits, 6th input has %d bits, 7th input has %d bits, 8th input has %d bits."))(n_52)(m_18)(a_12)(b_11)(c_5)(d_5)(e_5)(f_5), ofArray([getConnectionIdForPort_1(0), getConnectionIdForPort_1(1), getConnectionIdForPort_1(2), getConnectionIdForPort_1(3), getConnectionIdForPort_1(4), getConnectionIdForPort_1(5), getConnectionIdForPort_1(6), getConnectionIdForPort_1(7)]))]);
                case 2:
                    return makeWidthInferErrorEqual(3, n_53, singleton(getConnectionIdForPort_1(8)));
                case 3:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_19, y_19) => (compare(x_19, y_19) | 0),
                    }), getOutputPortId(comp, 0), n_54)]);
                case 4:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_20, y_20) => (compare(x_20, y_20) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 15: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_10 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_10, n_57, n_58;
            if (!isEmpty(matchValue_10)) {
                if (head(matchValue_10) != null) {
                    if (!isEmpty(tail(matchValue_10))) {
                        if (head(tail(matchValue_10)) == null) {
                            if (isEmpty(tail(tail(matchValue_10)))) {
                                matchResult_10 = 0;
                                n_57 = head(matchValue_10);
                            }
                            else {
                                matchResult_10 = 3;
                            }
                        }
                        else if (head(tail(matchValue_10)) === 1) {
                            if (isEmpty(tail(tail(matchValue_10)))) {
                                matchResult_10 = 0;
                                n_57 = head(matchValue_10);
                            }
                            else {
                                matchResult_10 = 3;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_10)))) {
                            if (head(tail(matchValue_10)) !== 1) {
                                matchResult_10 = 1;
                                n_58 = head(tail(matchValue_10));
                            }
                            else {
                                matchResult_10 = 2;
                            }
                        }
                        else {
                            matchResult_10 = 3;
                        }
                    }
                    else {
                        matchResult_10 = 3;
                    }
                }
                else if (!isEmpty(tail(matchValue_10))) {
                    if (head(tail(matchValue_10)) != null) {
                        if (isEmpty(tail(tail(matchValue_10)))) {
                            if (head(tail(matchValue_10)) !== 1) {
                                matchResult_10 = 1;
                                n_58 = head(tail(matchValue_10));
                            }
                            else {
                                matchResult_10 = 2;
                            }
                        }
                        else {
                            matchResult_10 = 3;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_10)))) {
                        matchResult_10 = 2;
                    }
                    else {
                        matchResult_10 = 3;
                    }
                }
                else {
                    matchResult_10 = 3;
                }
            }
            else {
                matchResult_10 = 3;
            }
            switch (matchResult_10) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(FSharpMap__Add(empty_1({
                        Compare: (x_21, y_21) => (compare(x_21, y_21) | 0),
                    }), getOutputPortId(comp, 0), n_57), getOutputPortId(comp, 1), n_57)]);
                case 1:
                    return makeWidthInferErrorEqual(1, n_58, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_22, y_22) => (compare(x_22, y_22) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 16: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_11 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_11, n_61, n_62;
            if (!isEmpty(matchValue_11)) {
                if (head(matchValue_11) != null) {
                    if (!isEmpty(tail(matchValue_11))) {
                        if (head(tail(matchValue_11)) == null) {
                            if (isEmpty(tail(tail(matchValue_11)))) {
                                matchResult_11 = 0;
                                n_61 = head(matchValue_11);
                            }
                            else {
                                matchResult_11 = 3;
                            }
                        }
                        else if (head(tail(matchValue_11)) === 2) {
                            if (isEmpty(tail(tail(matchValue_11)))) {
                                matchResult_11 = 0;
                                n_61 = head(matchValue_11);
                            }
                            else {
                                matchResult_11 = 3;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_11)))) {
                            if (head(tail(matchValue_11)) !== 2) {
                                matchResult_11 = 1;
                                n_62 = head(tail(matchValue_11));
                            }
                            else {
                                matchResult_11 = 2;
                            }
                        }
                        else {
                            matchResult_11 = 3;
                        }
                    }
                    else {
                        matchResult_11 = 3;
                    }
                }
                else if (!isEmpty(tail(matchValue_11))) {
                    if (head(tail(matchValue_11)) != null) {
                        if (isEmpty(tail(tail(matchValue_11)))) {
                            if (head(tail(matchValue_11)) !== 2) {
                                matchResult_11 = 1;
                                n_62 = head(tail(matchValue_11));
                            }
                            else {
                                matchResult_11 = 2;
                            }
                        }
                        else {
                            matchResult_11 = 3;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_11)))) {
                        matchResult_11 = 2;
                    }
                    else {
                        matchResult_11 = 3;
                    }
                }
                else {
                    matchResult_11 = 3;
                }
            }
            else {
                matchResult_11 = 3;
            }
            switch (matchResult_11) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [fold((s, v) => add(getOutputPortId(comp, v), n_61, s), FSharpMap__Add(empty_1({
                        Compare: (x_23, y_23) => (compare(x_23, y_23) | 0),
                    }), getOutputPortId(comp, 0), n_61), toList(rangeDouble(1, 1, 3)))]);
                case 1:
                    return makeWidthInferErrorEqual(2, n_62, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_24, y_24) => (compare(x_24, y_24) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 17: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_12 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_12, n_65, n_66;
            if (!isEmpty(matchValue_12)) {
                if (head(matchValue_12) != null) {
                    if (!isEmpty(tail(matchValue_12))) {
                        if (head(tail(matchValue_12)) == null) {
                            if (isEmpty(tail(tail(matchValue_12)))) {
                                matchResult_12 = 0;
                                n_65 = head(matchValue_12);
                            }
                            else {
                                matchResult_12 = 3;
                            }
                        }
                        else if (head(tail(matchValue_12)) === 3) {
                            if (isEmpty(tail(tail(matchValue_12)))) {
                                matchResult_12 = 0;
                                n_65 = head(matchValue_12);
                            }
                            else {
                                matchResult_12 = 3;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_12)))) {
                            if (head(tail(matchValue_12)) !== 3) {
                                matchResult_12 = 1;
                                n_66 = head(tail(matchValue_12));
                            }
                            else {
                                matchResult_12 = 2;
                            }
                        }
                        else {
                            matchResult_12 = 3;
                        }
                    }
                    else {
                        matchResult_12 = 3;
                    }
                }
                else if (!isEmpty(tail(matchValue_12))) {
                    if (head(tail(matchValue_12)) != null) {
                        if (isEmpty(tail(tail(matchValue_12)))) {
                            if (head(tail(matchValue_12)) !== 3) {
                                matchResult_12 = 1;
                                n_66 = head(tail(matchValue_12));
                            }
                            else {
                                matchResult_12 = 2;
                            }
                        }
                        else {
                            matchResult_12 = 3;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_12)))) {
                        matchResult_12 = 2;
                    }
                    else {
                        matchResult_12 = 3;
                    }
                }
                else {
                    matchResult_12 = 3;
                }
            }
            else {
                matchResult_12 = 3;
            }
            switch (matchResult_12) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [fold((s_1, v_1) => add(getOutputPortId(comp, v_1), n_65, s_1), FSharpMap__Add(empty_1({
                        Compare: (x_25, y_25) => (compare(x_25, y_25) | 0),
                    }), getOutputPortId(comp, 0), n_65), toList(rangeDouble(1, 1, 7)))]);
                case 1:
                    return makeWidthInferErrorEqual(3, n_66, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_26, y_26) => (compare(x_26, y_26) | 0),
                    })]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 18: {
            const shifterWidth = matchValue.fields[1] | 0;
            const inputWidth = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const okOutMap = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_27, y_27) => (compare(x_27, y_27) | 0),
            }), getOutputPortId(comp, 0), inputWidth)]);
            const matchValue_13 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_13, n_72, n_73, n_74, x_28;
            if (!isEmpty(matchValue_13)) {
                if (head(matchValue_13) != null) {
                    if (!isEmpty(tail(matchValue_13))) {
                        if (isEmpty(tail(tail(matchValue_13)))) {
                            if (head(matchValue_13) !== inputWidth) {
                                matchResult_13 = 0;
                                n_72 = head(matchValue_13);
                            }
                            else if (head(tail(matchValue_13)) != null) {
                                if (head(tail(matchValue_13)) !== shifterWidth) {
                                    matchResult_13 = 1;
                                    n_73 = head(tail(matchValue_13));
                                }
                                else if (head(tail(matchValue_13)) > 32) {
                                    matchResult_13 = 2;
                                    n_74 = head(tail(matchValue_13));
                                }
                                else {
                                    matchResult_13 = 3;
                                }
                            }
                            else {
                                matchResult_13 = 3;
                            }
                        }
                        else {
                            matchResult_13 = 4;
                            x_28 = matchValue_13;
                        }
                    }
                    else {
                        matchResult_13 = 4;
                        x_28 = matchValue_13;
                    }
                }
                else if (!isEmpty(tail(matchValue_13))) {
                    if (head(tail(matchValue_13)) != null) {
                        if (isEmpty(tail(tail(matchValue_13)))) {
                            if (head(tail(matchValue_13)) !== shifterWidth) {
                                matchResult_13 = 1;
                                n_73 = head(tail(matchValue_13));
                            }
                            else if (head(tail(matchValue_13)) > 32) {
                                matchResult_13 = 2;
                                n_74 = head(tail(matchValue_13));
                            }
                            else {
                                matchResult_13 = 3;
                            }
                        }
                        else {
                            matchResult_13 = 4;
                            x_28 = matchValue_13;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_13)))) {
                        matchResult_13 = 3;
                    }
                    else {
                        matchResult_13 = 4;
                        x_28 = matchValue_13;
                    }
                }
                else {
                    matchResult_13 = 4;
                    x_28 = matchValue_13;
                }
            }
            else {
                matchResult_13 = 4;
                x_28 = matchValue_13;
            }
            switch (matchResult_13) {
                case 0:
                    return makeWidthInferErrorEqual(inputWidth, n_72, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorEqual(shifterWidth, n_73, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return makeWidthInferErrorMax(32, n_74, singleton(getConnectionIdForPort_1(1)));
                case 3:
                    return okOutMap;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_28)(comp.Type);
            }
        }
        case 19: {
            const numberOfBits = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 3, comp);
            const okOutMap_1 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(FSharpMap__Add(empty_1({
                Compare: (x_29, y_28) => (compare(x_29, y_28) | 0),
            }), getOutputPortId(comp, 0), numberOfBits), getOutputPortId(comp, 1), 1)]);
            const matchValue_14 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2]));
            let matchResult_14, n_82, n_83, n_84, x_30;
            if (!isEmpty(matchValue_14)) {
                if (head(matchValue_14) != null) {
                    if (!isEmpty(tail(matchValue_14))) {
                        if (!isEmpty(tail(tail(matchValue_14)))) {
                            if (isEmpty(tail(tail(tail(matchValue_14))))) {
                                if (head(matchValue_14) !== 1) {
                                    matchResult_14 = 0;
                                    n_82 = head(matchValue_14);
                                }
                                else if (head(tail(matchValue_14)) != null) {
                                    if (head(tail(matchValue_14)) !== numberOfBits) {
                                        matchResult_14 = 1;
                                        n_83 = head(tail(matchValue_14));
                                    }
                                    else if (head(tail(tail(matchValue_14))) != null) {
                                        if (head(tail(tail(matchValue_14))) !== numberOfBits) {
                                            matchResult_14 = 2;
                                            n_84 = head(tail(tail(matchValue_14)));
                                        }
                                        else {
                                            matchResult_14 = 3;
                                        }
                                    }
                                    else {
                                        matchResult_14 = 3;
                                    }
                                }
                                else if (head(tail(tail(matchValue_14))) != null) {
                                    if (head(tail(tail(matchValue_14))) !== numberOfBits) {
                                        matchResult_14 = 2;
                                        n_84 = head(tail(tail(matchValue_14)));
                                    }
                                    else {
                                        matchResult_14 = 3;
                                    }
                                }
                                else {
                                    matchResult_14 = 3;
                                }
                            }
                            else {
                                matchResult_14 = 4;
                                x_30 = matchValue_14;
                            }
                        }
                        else {
                            matchResult_14 = 4;
                            x_30 = matchValue_14;
                        }
                    }
                    else {
                        matchResult_14 = 4;
                        x_30 = matchValue_14;
                    }
                }
                else if (!isEmpty(tail(matchValue_14))) {
                    if (head(tail(matchValue_14)) != null) {
                        if (!isEmpty(tail(tail(matchValue_14)))) {
                            if (isEmpty(tail(tail(tail(matchValue_14))))) {
                                if (head(tail(matchValue_14)) !== numberOfBits) {
                                    matchResult_14 = 1;
                                    n_83 = head(tail(matchValue_14));
                                }
                                else if (head(tail(tail(matchValue_14))) != null) {
                                    if (head(tail(tail(matchValue_14))) !== numberOfBits) {
                                        matchResult_14 = 2;
                                        n_84 = head(tail(tail(matchValue_14)));
                                    }
                                    else {
                                        matchResult_14 = 3;
                                    }
                                }
                                else {
                                    matchResult_14 = 3;
                                }
                            }
                            else {
                                matchResult_14 = 4;
                                x_30 = matchValue_14;
                            }
                        }
                        else {
                            matchResult_14 = 4;
                            x_30 = matchValue_14;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_14)))) {
                        if (head(tail(tail(matchValue_14))) != null) {
                            if (isEmpty(tail(tail(tail(matchValue_14))))) {
                                if (head(tail(tail(matchValue_14))) !== numberOfBits) {
                                    matchResult_14 = 2;
                                    n_84 = head(tail(tail(matchValue_14)));
                                }
                                else {
                                    matchResult_14 = 3;
                                }
                            }
                            else {
                                matchResult_14 = 4;
                                x_30 = matchValue_14;
                            }
                        }
                        else if (isEmpty(tail(tail(tail(matchValue_14))))) {
                            matchResult_14 = 3;
                        }
                        else {
                            matchResult_14 = 4;
                            x_30 = matchValue_14;
                        }
                    }
                    else {
                        matchResult_14 = 4;
                        x_30 = matchValue_14;
                    }
                }
                else {
                    matchResult_14 = 4;
                    x_30 = matchValue_14;
                }
            }
            else {
                matchResult_14 = 4;
                x_30 = matchValue_14;
            }
            switch (matchResult_14) {
                case 0:
                    return makeWidthInferErrorEqual(1, n_82, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorEqual(numberOfBits, n_83, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return makeWidthInferErrorEqual(numberOfBits, n_84, singleton(getConnectionIdForPort_1(2)));
                case 3:
                    return okOutMap_1;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_30)(comp.Type);
            }
        }
        case 20: {
            const numberOfBits_1 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 3, comp);
            const okOutMap_2 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_31, y_29) => (compare(x_31, y_29) | 0),
            }), getOutputPortId(comp, 0), numberOfBits_1)]);
            const matchValue_15 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2]));
            let matchResult_15, n_92, n_93, n_94, x_32;
            if (!isEmpty(matchValue_15)) {
                if (head(matchValue_15) != null) {
                    if (!isEmpty(tail(matchValue_15))) {
                        if (!isEmpty(tail(tail(matchValue_15)))) {
                            if (isEmpty(tail(tail(tail(matchValue_15))))) {
                                if (head(matchValue_15) !== 1) {
                                    matchResult_15 = 0;
                                    n_92 = head(matchValue_15);
                                }
                                else if (head(tail(matchValue_15)) != null) {
                                    if (head(tail(matchValue_15)) !== numberOfBits_1) {
                                        matchResult_15 = 1;
                                        n_93 = head(tail(matchValue_15));
                                    }
                                    else if (head(tail(tail(matchValue_15))) != null) {
                                        if (head(tail(tail(matchValue_15))) !== numberOfBits_1) {
                                            matchResult_15 = 2;
                                            n_94 = head(tail(tail(matchValue_15)));
                                        }
                                        else {
                                            matchResult_15 = 3;
                                        }
                                    }
                                    else {
                                        matchResult_15 = 3;
                                    }
                                }
                                else if (head(tail(tail(matchValue_15))) != null) {
                                    if (head(tail(tail(matchValue_15))) !== numberOfBits_1) {
                                        matchResult_15 = 2;
                                        n_94 = head(tail(tail(matchValue_15)));
                                    }
                                    else {
                                        matchResult_15 = 3;
                                    }
                                }
                                else {
                                    matchResult_15 = 3;
                                }
                            }
                            else {
                                matchResult_15 = 4;
                                x_32 = matchValue_15;
                            }
                        }
                        else {
                            matchResult_15 = 4;
                            x_32 = matchValue_15;
                        }
                    }
                    else {
                        matchResult_15 = 4;
                        x_32 = matchValue_15;
                    }
                }
                else if (!isEmpty(tail(matchValue_15))) {
                    if (head(tail(matchValue_15)) != null) {
                        if (!isEmpty(tail(tail(matchValue_15)))) {
                            if (isEmpty(tail(tail(tail(matchValue_15))))) {
                                if (head(tail(matchValue_15)) !== numberOfBits_1) {
                                    matchResult_15 = 1;
                                    n_93 = head(tail(matchValue_15));
                                }
                                else if (head(tail(tail(matchValue_15))) != null) {
                                    if (head(tail(tail(matchValue_15))) !== numberOfBits_1) {
                                        matchResult_15 = 2;
                                        n_94 = head(tail(tail(matchValue_15)));
                                    }
                                    else {
                                        matchResult_15 = 3;
                                    }
                                }
                                else {
                                    matchResult_15 = 3;
                                }
                            }
                            else {
                                matchResult_15 = 4;
                                x_32 = matchValue_15;
                            }
                        }
                        else {
                            matchResult_15 = 4;
                            x_32 = matchValue_15;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_15)))) {
                        if (head(tail(tail(matchValue_15))) != null) {
                            if (isEmpty(tail(tail(tail(matchValue_15))))) {
                                if (head(tail(tail(matchValue_15))) !== numberOfBits_1) {
                                    matchResult_15 = 2;
                                    n_94 = head(tail(tail(matchValue_15)));
                                }
                                else {
                                    matchResult_15 = 3;
                                }
                            }
                            else {
                                matchResult_15 = 4;
                                x_32 = matchValue_15;
                            }
                        }
                        else if (isEmpty(tail(tail(tail(matchValue_15))))) {
                            matchResult_15 = 3;
                        }
                        else {
                            matchResult_15 = 4;
                            x_32 = matchValue_15;
                        }
                    }
                    else {
                        matchResult_15 = 4;
                        x_32 = matchValue_15;
                    }
                }
                else {
                    matchResult_15 = 4;
                    x_32 = matchValue_15;
                }
            }
            else {
                matchResult_15 = 4;
                x_32 = matchValue_15;
            }
            switch (matchResult_15) {
                case 0:
                    return makeWidthInferErrorEqual(1, n_92, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorEqual(numberOfBits_1, n_93, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return makeWidthInferErrorEqual(numberOfBits_1, n_94, singleton(getConnectionIdForPort_1(2)));
                case 3:
                    return okOutMap_2;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_32)(comp.Type);
            }
        }
        case 21: {
            const numberOfBits_2 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const okOutMap_3 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(FSharpMap__Add(empty_1({
                Compare: (x_33, y_30) => (compare(x_33, y_30) | 0),
            }), getOutputPortId(comp, 0), numberOfBits_2), getOutputPortId(comp, 1), 1)]);
            const matchValue_16 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_16, n_98, n_99, x_34;
            if (!isEmpty(matchValue_16)) {
                if (head(matchValue_16) != null) {
                    if (!isEmpty(tail(matchValue_16))) {
                        if (isEmpty(tail(tail(matchValue_16)))) {
                            if (head(matchValue_16) !== numberOfBits_2) {
                                matchResult_16 = 0;
                                n_98 = head(matchValue_16);
                            }
                            else if (head(tail(matchValue_16)) != null) {
                                if (head(tail(matchValue_16)) !== numberOfBits_2) {
                                    matchResult_16 = 1;
                                    n_99 = head(tail(matchValue_16));
                                }
                                else {
                                    matchResult_16 = 2;
                                }
                            }
                            else {
                                matchResult_16 = 2;
                            }
                        }
                        else {
                            matchResult_16 = 3;
                            x_34 = matchValue_16;
                        }
                    }
                    else {
                        matchResult_16 = 3;
                        x_34 = matchValue_16;
                    }
                }
                else if (!isEmpty(tail(matchValue_16))) {
                    if (head(tail(matchValue_16)) != null) {
                        if (isEmpty(tail(tail(matchValue_16)))) {
                            if (head(tail(matchValue_16)) !== numberOfBits_2) {
                                matchResult_16 = 1;
                                n_99 = head(tail(matchValue_16));
                            }
                            else {
                                matchResult_16 = 2;
                            }
                        }
                        else {
                            matchResult_16 = 3;
                            x_34 = matchValue_16;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_16)))) {
                        matchResult_16 = 2;
                    }
                    else {
                        matchResult_16 = 3;
                        x_34 = matchValue_16;
                    }
                }
                else {
                    matchResult_16 = 3;
                    x_34 = matchValue_16;
                }
            }
            else {
                matchResult_16 = 3;
                x_34 = matchValue_16;
            }
            switch (matchResult_16) {
                case 0:
                    return makeWidthInferErrorEqual(numberOfBits_2, n_98, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorEqual(numberOfBits_2, n_99, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return okOutMap_3;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_34)(comp.Type);
            }
        }
        case 22: {
            const numberOfBits_3 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const okOutMap_4 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_35, y_31) => (compare(x_35, y_31) | 0),
            }), getOutputPortId(comp, 0), numberOfBits_3)]);
            const matchValue_17 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_17, n_103, n_104, x_36;
            if (!isEmpty(matchValue_17)) {
                if (head(matchValue_17) != null) {
                    if (!isEmpty(tail(matchValue_17))) {
                        if (isEmpty(tail(tail(matchValue_17)))) {
                            if (head(matchValue_17) !== numberOfBits_3) {
                                matchResult_17 = 0;
                                n_103 = head(matchValue_17);
                            }
                            else if (head(tail(matchValue_17)) != null) {
                                if (head(tail(matchValue_17)) !== numberOfBits_3) {
                                    matchResult_17 = 1;
                                    n_104 = head(tail(matchValue_17));
                                }
                                else {
                                    matchResult_17 = 2;
                                }
                            }
                            else {
                                matchResult_17 = 2;
                            }
                        }
                        else {
                            matchResult_17 = 3;
                            x_36 = matchValue_17;
                        }
                    }
                    else {
                        matchResult_17 = 3;
                        x_36 = matchValue_17;
                    }
                }
                else if (!isEmpty(tail(matchValue_17))) {
                    if (head(tail(matchValue_17)) != null) {
                        if (isEmpty(tail(tail(matchValue_17)))) {
                            if (head(tail(matchValue_17)) !== numberOfBits_3) {
                                matchResult_17 = 1;
                                n_104 = head(tail(matchValue_17));
                            }
                            else {
                                matchResult_17 = 2;
                            }
                        }
                        else {
                            matchResult_17 = 3;
                            x_36 = matchValue_17;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_17)))) {
                        matchResult_17 = 2;
                    }
                    else {
                        matchResult_17 = 3;
                        x_36 = matchValue_17;
                    }
                }
                else {
                    matchResult_17 = 3;
                    x_36 = matchValue_17;
                }
            }
            else {
                matchResult_17 = 3;
                x_36 = matchValue_17;
            }
            switch (matchResult_17) {
                case 0:
                    return makeWidthInferErrorEqual(numberOfBits_3, n_103, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorEqual(numberOfBits_3, n_104, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return okOutMap_4;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_36)(comp.Type);
            }
        }
        case 23: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const okOutMap_5 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_37, y_32) => (compare(x_37, y_32) | 0),
            }), getOutputPortId(comp, 0), numberOfBits_4)]);
            const matchValue_18 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_18, n_108, n_109, x_38;
            if (!isEmpty(matchValue_18)) {
                if (head(matchValue_18) != null) {
                    if (!isEmpty(tail(matchValue_18))) {
                        if (isEmpty(tail(tail(matchValue_18)))) {
                            if (head(matchValue_18) !== numberOfBits_4) {
                                matchResult_18 = 0;
                                n_108 = head(matchValue_18);
                            }
                            else if (head(tail(matchValue_18)) != null) {
                                if (head(tail(matchValue_18)) !== numberOfBits_4) {
                                    matchResult_18 = 1;
                                    n_109 = head(tail(matchValue_18));
                                }
                                else {
                                    matchResult_18 = 2;
                                }
                            }
                            else {
                                matchResult_18 = 2;
                            }
                        }
                        else {
                            matchResult_18 = 3;
                            x_38 = matchValue_18;
                        }
                    }
                    else {
                        matchResult_18 = 3;
                        x_38 = matchValue_18;
                    }
                }
                else if (!isEmpty(tail(matchValue_18))) {
                    if (head(tail(matchValue_18)) != null) {
                        if (isEmpty(tail(tail(matchValue_18)))) {
                            if (head(tail(matchValue_18)) !== numberOfBits_4) {
                                matchResult_18 = 1;
                                n_109 = head(tail(matchValue_18));
                            }
                            else {
                                matchResult_18 = 2;
                            }
                        }
                        else {
                            matchResult_18 = 3;
                            x_38 = matchValue_18;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_18)))) {
                        matchResult_18 = 2;
                    }
                    else {
                        matchResult_18 = 3;
                        x_38 = matchValue_18;
                    }
                }
                else {
                    matchResult_18 = 3;
                    x_38 = matchValue_18;
                }
            }
            else {
                matchResult_18 = 3;
                x_38 = matchValue_18;
            }
            switch (matchResult_18) {
                case 0:
                    return makeWidthInferErrorEqual(1, n_108, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorEqual(numberOfBits_4, n_109, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return okOutMap_5;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_38)(comp.Type);
            }
        }
        case 24: {
            const numberOfBits_5 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const okOutMap_6 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_39, y_33) => (compare(x_39, y_33) | 0),
            }), getOutputPortId(comp, 0), numberOfBits_5)]);
            const matchValue_19 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_19, n_111, x_40;
            if (!isEmpty(matchValue_19)) {
                if (head(matchValue_19) != null) {
                    if (isEmpty(tail(matchValue_19))) {
                        if (head(matchValue_19) !== numberOfBits_5) {
                            matchResult_19 = 0;
                            n_111 = head(matchValue_19);
                        }
                        else {
                            matchResult_19 = 1;
                        }
                    }
                    else {
                        matchResult_19 = 2;
                        x_40 = matchValue_19;
                    }
                }
                else if (isEmpty(tail(matchValue_19))) {
                    matchResult_19 = 1;
                }
                else {
                    matchResult_19 = 2;
                    x_40 = matchValue_19;
                }
            }
            else {
                matchResult_19 = 2;
                x_40 = matchValue_19;
            }
            switch (matchResult_19) {
                case 0:
                    return makeWidthInferErrorEqual(numberOfBits_5, n_111, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return okOutMap_6;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_40)(comp.Type);
            }
        }
        case 25: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const okOutMap_7 = new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_41, y_34) => (compare(x_41, y_34) | 0),
            }), getOutputPortId(comp, 0), matchValue.fields[0])]);
            const matchValue_20 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_20, n_113, x_42;
            if (!isEmpty(matchValue_20)) {
                if (head(matchValue_20) != null) {
                    if (isEmpty(tail(matchValue_20))) {
                        if (head(matchValue_20) !== 1) {
                            matchResult_20 = 0;
                            n_113 = head(matchValue_20);
                        }
                        else {
                            matchResult_20 = 1;
                        }
                    }
                    else {
                        matchResult_20 = 2;
                        x_42 = matchValue_20;
                    }
                }
                else if (isEmpty(tail(matchValue_20))) {
                    matchResult_20 = 1;
                }
                else {
                    matchResult_20 = 2;
                    x_42 = matchValue_20;
                }
            }
            else {
                matchResult_20 = 2;
                x_42 = matchValue_20;
            }
            switch (matchResult_20) {
                case 0:
                    return makeWidthInferErrorEqual(1, n_113, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return okOutMap_7;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_42)(comp.Type);
            }
        }
        case 26: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const okOutMap_8 = new FSharpResult$2(/* Ok */ 0, [ofList_1(map_2((n_114) => [getOutputPortId(comp, n_114), 1], toList(rangeDouble(0, 1, 3))), {
                Compare: (x_43, y_35) => (compare(x_43, y_35) | 0),
            })]);
            const matchValue_21 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_21, n_121, n_122, x_44;
            if (!isEmpty(matchValue_21)) {
                if (head(matchValue_21) != null) {
                    if (head(matchValue_21) === 2) {
                        if (!isEmpty(tail(matchValue_21))) {
                            if (head(tail(matchValue_21)) != null) {
                                if (head(tail(matchValue_21)) === 1) {
                                    if (isEmpty(tail(tail(matchValue_21)))) {
                                        matchResult_21 = 0;
                                    }
                                    else {
                                        matchResult_21 = 4;
                                        x_44 = matchValue_21;
                                    }
                                }
                                else if (isEmpty(tail(tail(matchValue_21)))) {
                                    if (head(matchValue_21) !== 2) {
                                        matchResult_21 = 1;
                                        n_121 = head(matchValue_21);
                                    }
                                    else if (head(tail(matchValue_21)) !== 1) {
                                        matchResult_21 = 2;
                                        n_122 = head(tail(matchValue_21));
                                    }
                                    else {
                                        matchResult_21 = 3;
                                    }
                                }
                                else {
                                    matchResult_21 = 4;
                                    x_44 = matchValue_21;
                                }
                            }
                            else if (isEmpty(tail(tail(matchValue_21)))) {
                                if (head(matchValue_21) !== 2) {
                                    matchResult_21 = 1;
                                    n_121 = head(matchValue_21);
                                }
                                else {
                                    matchResult_21 = 3;
                                }
                            }
                            else {
                                matchResult_21 = 4;
                                x_44 = matchValue_21;
                            }
                        }
                        else {
                            matchResult_21 = 4;
                            x_44 = matchValue_21;
                        }
                    }
                    else if (!isEmpty(tail(matchValue_21))) {
                        if (isEmpty(tail(tail(matchValue_21)))) {
                            if (head(matchValue_21) !== 2) {
                                matchResult_21 = 1;
                                n_121 = head(matchValue_21);
                            }
                            else if (head(tail(matchValue_21)) != null) {
                                if (head(tail(matchValue_21)) !== 1) {
                                    matchResult_21 = 2;
                                    n_122 = head(tail(matchValue_21));
                                }
                                else {
                                    matchResult_21 = 3;
                                }
                            }
                            else {
                                matchResult_21 = 3;
                            }
                        }
                        else {
                            matchResult_21 = 4;
                            x_44 = matchValue_21;
                        }
                    }
                    else {
                        matchResult_21 = 4;
                        x_44 = matchValue_21;
                    }
                }
                else if (!isEmpty(tail(matchValue_21))) {
                    if (head(tail(matchValue_21)) != null) {
                        if (isEmpty(tail(tail(matchValue_21)))) {
                            if (head(tail(matchValue_21)) !== 1) {
                                matchResult_21 = 2;
                                n_122 = head(tail(matchValue_21));
                            }
                            else {
                                matchResult_21 = 3;
                            }
                        }
                        else {
                            matchResult_21 = 4;
                            x_44 = matchValue_21;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_21)))) {
                        matchResult_21 = 3;
                    }
                    else {
                        matchResult_21 = 4;
                        x_44 = matchValue_21;
                    }
                }
                else {
                    matchResult_21 = 4;
                    x_44 = matchValue_21;
                }
            }
            else {
                matchResult_21 = 4;
                x_44 = matchValue_21;
            }
            switch (matchResult_21) {
                case 0:
                    return okOutMap_8;
                case 1:
                    return makeWidthInferErrorEqual(2, n_121, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return makeWidthInferErrorEqual(1, n_122, singleton(getConnectionIdForPort_1(1)));
                case 3:
                    return okOutMap_8;
                default:
                    return toFail(printf("what? Impossible case (%A) in calculateOutputPortsWidth for: %A"))(x_44)(comp.Type);
            }
        }
        case 27: {
            const custom = matchValue.fields[0];
            assertInputsSize(inputConnectionsWidth, length(custom.InputLabels), comp);
            const matchValue_22 = tryFind((el) => !equals(el, undefined), mapIndexed2((idx_1, actual, tupledArg) => {
                const expected = tupledArg[1] | 0;
                if (actual != null) {
                    if (actual === expected) {
                        const w_1 = actual | 0;
                        return undefined;
                    }
                    else {
                        const w_2 = actual | 0;
                        return makeWidthInferErrorEqual(expected, w_2, singleton(getConnectionIdForPort_1(idx_1)));
                    }
                }
                else {
                    return undefined;
                }
            }, getWidthsForPorts(inputConnectionsWidth, map_2((Item_1) => (Item_1 | 0), toList(rangeDouble(0, 1, length(custom.InputLabels) - 1)))), custom.InputLabels));
            if (matchValue_22 == null) {
                return new FSharpResult$2(/* Ok */ 0, [ofList_1(mapIndexed((idx_2, tupledArg_1) => [getOutputPortId(comp, idx_2), tupledArg_1[1]], custom.OutputLabels), {
                    Compare: (x_45, y_36) => (compare(x_45, y_36) | 0),
                })]);
            }
            else if (value_1(matchValue_22) != null) {
                const err = value_1(matchValue_22);
                return err;
            }
            else {
                return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 28: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_23 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_22, n_124, m_22, m_23, n_125;
            if (!isEmpty(matchValue_23)) {
                if (head(matchValue_23) == null) {
                    if (!isEmpty(tail(matchValue_23))) {
                        if (head(tail(matchValue_23)) == null) {
                            if (isEmpty(tail(tail(matchValue_23)))) {
                                matchResult_22 = 2;
                            }
                            else {
                                matchResult_22 = 4;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_23)))) {
                            if (head(tail(matchValue_23)) < 1) {
                                matchResult_22 = 1;
                                m_22 = head(tail(matchValue_23));
                            }
                            else {
                                matchResult_22 = 2;
                            }
                        }
                        else {
                            matchResult_22 = 4;
                        }
                    }
                    else {
                        matchResult_22 = 4;
                    }
                }
                else if (!isEmpty(tail(matchValue_23))) {
                    if (isEmpty(tail(tail(matchValue_23)))) {
                        if (head(matchValue_23) < 1) {
                            matchResult_22 = 0;
                            n_124 = head(matchValue_23);
                        }
                        else if (head(tail(matchValue_23)) == null) {
                            matchResult_22 = 2;
                        }
                        else if (head(tail(matchValue_23)) < 1) {
                            matchResult_22 = 1;
                            m_22 = head(tail(matchValue_23));
                        }
                        else {
                            matchResult_22 = 3;
                            m_23 = head(tail(matchValue_23));
                            n_125 = head(matchValue_23);
                        }
                    }
                    else {
                        matchResult_22 = 4;
                    }
                }
                else {
                    matchResult_22 = 4;
                }
            }
            else {
                matchResult_22 = 4;
            }
            switch (matchResult_22) {
                case 0:
                    return makeWidthInferErrorAtLeast(1, n_124, singleton(getConnectionIdForPort_1(0)));
                case 1:
                    return makeWidthInferErrorAtLeast(1, m_22, singleton(getConnectionIdForPort_1(1)));
                case 2:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_46, y_37) => (compare(x_46, y_37) | 0),
                    })]);
                case 3:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_47, y_38) => (compare(x_47, y_38) | 0),
                    }), getOutputPortId(comp, 0), n_125 + m_23)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 29: {
            const n_126 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, n_126, comp);
            const portWidths_1 = getWidthsForPorts(inputConnectionsWidth, initialize(n_126, (i_1) => (i_1 | 0)));
            const matchValue_24 = tryFind((el_1) => !equals(el_1, undefined), mapIndexed((idx_3, width_6) => {
                let matchResult_23, w_5;
                if (width_6 != null) {
                    if (width_6 < 1) {
                        matchResult_23 = 0;
                        w_5 = width_6;
                    }
                    else {
                        matchResult_23 = 1;
                    }
                }
                else {
                    matchResult_23 = 1;
                }
                switch (matchResult_23) {
                    case 0:
                        return makeWidthInferErrorAtLeast(1, w_5, singleton(getConnectionIdForPort_1(idx_3)));
                    default:
                        return undefined;
                }
            }, portWidths_1));
            if (matchValue_24 == null) {
                if (exists((el_2) => equals(el_2, undefined), portWidths_1)) {
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_48, y_39) => (compare(x_48, y_39) | 0),
                    })]);
                }
                else {
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_52, y_41) => (compare(x_52, y_41) | 0),
                    }), getOutputPortId(comp, 0), sumBy((x_49) => {
                        if (x_49 == null) {
                            return 0;
                        }
                        else {
                            return x_49 | 0;
                        }
                    }, portWidths_1, {
                        GetZero: () => 0,
                        Add: (x_51, y_40) => ((x_51 + y_40) | 0),
                    }))]);
                }
            }
            else if (value_1(matchValue_24) != null) {
                const err_1 = value_1(matchValue_24);
                return err_1;
            }
            else {
                return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 30: {
            const n_127 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, n_127, comp);
            const portWidths_2 = getWidthsForPorts(inputConnectionsWidth, initialize(n_127, (i_2) => (i_2 | 0)));
            if (exists((option) => (option == null), portWidths_2)) {
                return new FSharpResult$2(/* Ok */ 0, [empty_1({
                    Compare: (x_53, y_42) => (compare(x_53, y_42) | 0),
                })]);
            }
            else {
                const widths = map_2((option_1) => (value_1(option_1) | 0), portWidths_2);
                const matchValue_27 = tryFindIndex((w_6) => (w_6 !== head(widths)), widths);
                if (matchValue_27 == null) {
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_54, y_43) => (compare(x_54, y_43) | 0),
                    }), getOutputPortId(comp, 0), head(widths) * n_127)]);
                }
                else {
                    const idx_4 = matchValue_27 | 0;
                    return makeWidthInferErrorEqual(head(widths), item(idx_4, widths), singleton(getConnectionIdForPort_1(idx_4)));
                }
            }
        }
        case 31: {
            const n_128 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, n_128 + 1, comp);
            const dataWidths = getWidthsForPorts(inputConnectionsWidth, initialize(n_128, (i_3) => (i_3 | 0)));
            const selWidth = max_1(1, ~~toInt32(clog2(fromInt32(n_128)))) | 0;
            const selGiven = getWidthsForPorts(inputConnectionsWidth, singleton(n_128));
            let matchResult_24, w_8;
            if (!isEmpty(selGiven)) {
                if (head(selGiven) != null) {
                    if (isEmpty(tail(selGiven))) {
                        if (head(selGiven) !== selWidth) {
                            matchResult_24 = 0;
                            w_8 = head(selGiven);
                        }
                        else {
                            matchResult_24 = 1;
                        }
                    }
                    else {
                        matchResult_24 = 1;
                    }
                }
                else {
                    matchResult_24 = 1;
                }
            }
            else {
                matchResult_24 = 1;
            }
            switch (matchResult_24) {
                case 0:
                    return makeWidthInferErrorEqual(selWidth, w_8, singleton(getConnectionIdForPort_1(n_128)));
                default:
                    if (exists((option_2) => (option_2 == null), dataWidths)) {
                        return new FSharpResult$2(/* Ok */ 0, [empty_1({
                            Compare: (x_55, y_44) => (compare(x_55, y_44) | 0),
                        })]);
                    }
                    else {
                        const widths_1 = map_2((option_3) => (value_1(option_3) | 0), dataWidths);
                        const matchValue_29 = tryFindIndex((w_9) => (w_9 !== head(widths_1)), widths_1);
                        if (matchValue_29 == null) {
                            return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                                Compare: (x_56, y_45) => (compare(x_56, y_45) | 0),
                            }), getOutputPortId(comp, 0), head(widths_1))]);
                        }
                        else {
                            const idx_5 = matchValue_29 | 0;
                            return makeWidthInferErrorEqual(head(widths_1), item(idx_5, widths_1), singleton(getConnectionIdForPort_1(idx_5)));
                        }
                    }
            }
        }
        case 32: {
            const topWireWidth = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_30 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_25, n_130, n_131;
            if (!isEmpty(matchValue_30)) {
                if (head(matchValue_30) != null) {
                    if (isEmpty(tail(matchValue_30))) {
                        if (head(matchValue_30) < (topWireWidth + 1)) {
                            matchResult_25 = 1;
                            n_130 = head(matchValue_30);
                        }
                        else {
                            matchResult_25 = 2;
                            n_131 = head(matchValue_30);
                        }
                    }
                    else {
                        matchResult_25 = 3;
                    }
                }
                else if (isEmpty(tail(matchValue_30))) {
                    matchResult_25 = 0;
                }
                else {
                    matchResult_25 = 3;
                }
            }
            else {
                matchResult_25 = 3;
            }
            switch (matchResult_25) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [empty_1({
                        Compare: (x_57, y_46) => (compare(x_57, y_46) | 0),
                    })]);
                case 1:
                    return makeWidthInferErrorAtLeast(topWireWidth + 1, n_130, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(FSharpMap__Add(empty_1({
                        Compare: (x_58, y_47) => (compare(x_58, y_47) | 0),
                    }), getOutputPortId(comp, 0), topWireWidth), getOutputPortId(comp, 1), n_131 - topWireWidth)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 33: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_31 = checkedMap3((index, width_7, lsb) => [index, width_7, (lsb + width_7) - 1], toList(rangeDouble(0, 1, matchValue.fields[0] - 1)), matchValue.fields[1], matchValue.fields[2]);
            if (matchValue_31.tag === 0) {
                if (isEmpty(matchValue_31.fields[0])) {
                    return makeComponentInconsistentError("This SplitN has no outputs. Delete it and place a new one.");
                }
                else {
                    const outputs = matchValue_31.fields[0];
                    const msb_1 = max_2(map_2((tupledArg_2) => (tupledArg_2[2] | 0), outputs), {
                        Compare: (x_59, y_48) => (comparePrimitives(x_59, y_48) | 0),
                    }) | 0;
                    const matchValue_32 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
                    let matchResult_26, inWidth_1;
                    if (!isEmpty(matchValue_32)) {
                        if (head(matchValue_32) != null) {
                            if (isEmpty(tail(matchValue_32))) {
                                if (head(matchValue_32) < (msb_1 + 1)) {
                                    matchResult_26 = 1;
                                    inWidth_1 = head(matchValue_32);
                                }
                                else {
                                    matchResult_26 = 2;
                                }
                            }
                            else {
                                matchResult_26 = 3;
                            }
                        }
                        else if (isEmpty(tail(matchValue_32))) {
                            matchResult_26 = 0;
                        }
                        else {
                            matchResult_26 = 3;
                        }
                    }
                    else {
                        matchResult_26 = 3;
                    }
                    switch (matchResult_26) {
                        case 0:
                            return new FSharpResult$2(/* Ok */ 0, [empty_1({
                                Compare: (x_60, y_49) => (compare(x_60, y_49) | 0),
                            })]);
                        case 1:
                            return makeWidthInferErrorAtLeast(msb_1 + 1, inWidth_1, singleton(getConnectionIdForPort_1(0)));
                        case 2:
                            return new FSharpResult$2(/* Ok */ 0, [fold((acc, tupledArg_3) => FSharpMap__Add(acc, getOutputPortId(comp, tupledArg_3[0]), tupledArg_3[1]), empty_1({
                                Compare: (x_61, y_50) => (compare(x_61, y_50) | 0),
                            }), outputs)]);
                        default:
                            return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
                    }
                }
            }
            else {
                return makeComponentInconsistentError(toText(printf("This SplitN does not hold together: it says it has %d outputs, and carries %d widths and %d LSBs. Delete it and place a new one."))(matchValue_31.fields[0][0])(matchValue_31.fields[0][1])(matchValue_31.fields[0][2]));
            }
        }
        case 34: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_33 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_27, n_133;
            if (!isEmpty(matchValue_33)) {
                if (head(matchValue_33) != null) {
                    if (head(matchValue_33) === 1) {
                        if (isEmpty(tail(matchValue_33))) {
                            matchResult_27 = 0;
                        }
                        else {
                            matchResult_27 = 2;
                        }
                    }
                    else if (isEmpty(tail(matchValue_33))) {
                        matchResult_27 = 1;
                        n_133 = head(matchValue_33);
                    }
                    else {
                        matchResult_27 = 2;
                    }
                }
                else if (isEmpty(tail(matchValue_33))) {
                    matchResult_27 = 0;
                }
                else {
                    matchResult_27 = 2;
                }
            }
            else {
                matchResult_27 = 2;
            }
            switch (matchResult_27) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_62, y_51) => (compare(x_62, y_51) | 0),
                    }), getOutputPortId(comp, 0), 1)]);
                case 1:
                    return makeWidthInferErrorEqual(1, n_133, singleton(getConnectionIdForPort_1(0)));
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 35: {
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_34 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_28, n_139, n_140;
            if (!isEmpty(matchValue_34)) {
                if (head(matchValue_34) != null) {
                    if (head(matchValue_34) === 1) {
                        if (!isEmpty(tail(matchValue_34))) {
                            if (head(tail(matchValue_34)) != null) {
                                if (head(tail(matchValue_34)) === 1) {
                                    if (isEmpty(tail(tail(matchValue_34)))) {
                                        matchResult_28 = 0;
                                    }
                                    else {
                                        matchResult_28 = 3;
                                    }
                                }
                                else if (isEmpty(tail(tail(matchValue_34)))) {
                                    if (head(matchValue_34) !== 1) {
                                        matchResult_28 = 1;
                                        n_139 = head(matchValue_34);
                                    }
                                    else if (head(tail(matchValue_34)) !== 1) {
                                        matchResult_28 = 2;
                                        n_140 = head(tail(matchValue_34));
                                    }
                                    else {
                                        matchResult_28 = 3;
                                    }
                                }
                                else {
                                    matchResult_28 = 3;
                                }
                            }
                            else if (isEmpty(tail(tail(matchValue_34)))) {
                                matchResult_28 = 0;
                            }
                            else {
                                matchResult_28 = 3;
                            }
                        }
                        else {
                            matchResult_28 = 3;
                        }
                    }
                    else if (!isEmpty(tail(matchValue_34))) {
                        if (isEmpty(tail(tail(matchValue_34)))) {
                            if (head(matchValue_34) !== 1) {
                                matchResult_28 = 1;
                                n_139 = head(matchValue_34);
                            }
                            else if (head(tail(matchValue_34)) != null) {
                                if (head(tail(matchValue_34)) !== 1) {
                                    matchResult_28 = 2;
                                    n_140 = head(tail(matchValue_34));
                                }
                                else {
                                    matchResult_28 = 3;
                                }
                            }
                            else {
                                matchResult_28 = 3;
                            }
                        }
                        else {
                            matchResult_28 = 3;
                        }
                    }
                    else {
                        matchResult_28 = 3;
                    }
                }
                else if (!isEmpty(tail(matchValue_34))) {
                    if (head(tail(matchValue_34)) != null) {
                        if (head(tail(matchValue_34)) === 1) {
                            if (isEmpty(tail(tail(matchValue_34)))) {
                                matchResult_28 = 0;
                            }
                            else {
                                matchResult_28 = 3;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_34)))) {
                            if (head(tail(matchValue_34)) !== 1) {
                                matchResult_28 = 2;
                                n_140 = head(tail(matchValue_34));
                            }
                            else {
                                matchResult_28 = 3;
                            }
                        }
                        else {
                            matchResult_28 = 3;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_34)))) {
                        matchResult_28 = 0;
                    }
                    else {
                        matchResult_28 = 3;
                    }
                }
                else {
                    matchResult_28 = 3;
                }
            }
            else {
                matchResult_28 = 3;
            }
            switch (matchResult_28) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_63, y_52) => (compare(x_63, y_52) | 0),
                    }), getOutputPortId(comp, 0), 1)]);
                case 1:
                    return makeWidthInferErrorEqual(1, n_139, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return makeWidthInferErrorEqual(1, n_140, singleton(getConnectionIdForPort_1(1)));
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 36: {
            const width_9 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_35 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_29, n_143, n_144;
            if (!isEmpty(matchValue_35)) {
                if (head(matchValue_35) != null) {
                    if (isEmpty(tail(matchValue_35))) {
                        if (head(matchValue_35) === width_9) {
                            matchResult_29 = 1;
                            n_143 = head(matchValue_35);
                        }
                        else if (head(matchValue_35) !== width_9) {
                            matchResult_29 = 2;
                            n_144 = head(matchValue_35);
                        }
                        else {
                            matchResult_29 = 3;
                        }
                    }
                    else {
                        matchResult_29 = 3;
                    }
                }
                else if (isEmpty(tail(matchValue_35))) {
                    matchResult_29 = 0;
                }
                else {
                    matchResult_29 = 3;
                }
            }
            else {
                matchResult_29 = 3;
            }
            switch (matchResult_29) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_64, y_53) => (compare(x_64, y_53) | 0),
                    }), getOutputPortId(comp, 0), width_9)]);
                case 1:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_65, y_54) => (compare(x_65, y_54) | 0),
                    }), getOutputPortId(comp, 0), width_9)]);
                case 2:
                    return makeWidthInferErrorEqual(width_9, n_144, singleton(getConnectionIdForPort_1(0)));
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 37: {
            const width_10 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_36 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_30, n_152, n_153, n_154;
            if (!isEmpty(matchValue_36)) {
                if (head(matchValue_36) != null) {
                    if (!isEmpty(tail(matchValue_36))) {
                        if (head(tail(matchValue_36)) != null) {
                            if (head(tail(matchValue_36)) === 1) {
                                if (isEmpty(tail(tail(matchValue_36)))) {
                                    if (head(matchValue_36) === width_10) {
                                        matchResult_30 = 0;
                                        n_152 = head(matchValue_36);
                                    }
                                    else if (head(matchValue_36) !== width_10) {
                                        matchResult_30 = 1;
                                        n_153 = head(matchValue_36);
                                    }
                                    else if (head(tail(matchValue_36)) !== 1) {
                                        matchResult_30 = 2;
                                        n_154 = head(tail(matchValue_36));
                                    }
                                    else {
                                        matchResult_30 = 3;
                                    }
                                }
                                else {
                                    matchResult_30 = 4;
                                }
                            }
                            else if (isEmpty(tail(tail(matchValue_36)))) {
                                if (head(matchValue_36) !== width_10) {
                                    matchResult_30 = 1;
                                    n_153 = head(matchValue_36);
                                }
                                else if (head(tail(matchValue_36)) !== 1) {
                                    matchResult_30 = 2;
                                    n_154 = head(tail(matchValue_36));
                                }
                                else {
                                    matchResult_30 = 3;
                                }
                            }
                            else {
                                matchResult_30 = 4;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_36)))) {
                            if (head(matchValue_36) !== width_10) {
                                matchResult_30 = 1;
                                n_153 = head(matchValue_36);
                            }
                            else {
                                matchResult_30 = 3;
                            }
                        }
                        else {
                            matchResult_30 = 4;
                        }
                    }
                    else {
                        matchResult_30 = 4;
                    }
                }
                else if (!isEmpty(tail(matchValue_36))) {
                    if (head(tail(matchValue_36)) != null) {
                        if (isEmpty(tail(tail(matchValue_36)))) {
                            if (head(tail(matchValue_36)) !== 1) {
                                matchResult_30 = 2;
                                n_154 = head(tail(matchValue_36));
                            }
                            else {
                                matchResult_30 = 3;
                            }
                        }
                        else {
                            matchResult_30 = 4;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_36)))) {
                        matchResult_30 = 3;
                    }
                    else {
                        matchResult_30 = 4;
                    }
                }
                else {
                    matchResult_30 = 4;
                }
            }
            else {
                matchResult_30 = 4;
            }
            switch (matchResult_30) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_66, y_55) => (compare(x_66, y_55) | 0),
                    }), getOutputPortId(comp, 0), width_10)]);
                case 1:
                    return makeWidthInferErrorEqual(width_10, n_153, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return makeWidthInferErrorEqual(1, n_154, singleton(getConnectionIdForPort_1(1)));
                case 3:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_67, y_56) => (compare(x_67, y_56) | 0),
                    }), getOutputPortId(comp, 0), width_10)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 38: {
            const width_11 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 3, comp);
            const matchValue_37 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2]));
            let matchResult_31, n_172, n_173, n_174, n_175;
            if (!isEmpty(matchValue_37)) {
                if (head(matchValue_37) != null) {
                    if (!isEmpty(tail(matchValue_37))) {
                        if (head(tail(matchValue_37)) != null) {
                            if (head(tail(matchValue_37)) === 1) {
                                if (!isEmpty(tail(tail(matchValue_37)))) {
                                    if (head(tail(tail(matchValue_37))) != null) {
                                        if (head(tail(tail(matchValue_37))) === 1) {
                                            if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                                if (head(matchValue_37) === width_11) {
                                                    matchResult_31 = 0;
                                                    n_172 = head(matchValue_37);
                                                }
                                                else if (head(matchValue_37) !== width_11) {
                                                    matchResult_31 = 1;
                                                    n_173 = head(matchValue_37);
                                                }
                                                else if (head(tail(matchValue_37)) !== 1) {
                                                    matchResult_31 = 2;
                                                    n_174 = head(tail(matchValue_37));
                                                }
                                                else if (head(tail(tail(matchValue_37))) !== 1) {
                                                    matchResult_31 = 3;
                                                    n_175 = head(tail(tail(matchValue_37)));
                                                }
                                                else {
                                                    matchResult_31 = 4;
                                                }
                                            }
                                            else {
                                                matchResult_31 = 5;
                                            }
                                        }
                                        else if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                            if (head(matchValue_37) !== width_11) {
                                                matchResult_31 = 1;
                                                n_173 = head(matchValue_37);
                                            }
                                            else if (head(tail(matchValue_37)) !== 1) {
                                                matchResult_31 = 2;
                                                n_174 = head(tail(matchValue_37));
                                            }
                                            else if (head(tail(tail(matchValue_37))) !== 1) {
                                                matchResult_31 = 3;
                                                n_175 = head(tail(tail(matchValue_37)));
                                            }
                                            else {
                                                matchResult_31 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_31 = 5;
                                        }
                                    }
                                    else if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                        if (head(matchValue_37) !== width_11) {
                                            matchResult_31 = 1;
                                            n_173 = head(matchValue_37);
                                        }
                                        else if (head(tail(matchValue_37)) !== 1) {
                                            matchResult_31 = 2;
                                            n_174 = head(tail(matchValue_37));
                                        }
                                        else {
                                            matchResult_31 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_31 = 5;
                                    }
                                }
                                else {
                                    matchResult_31 = 5;
                                }
                            }
                            else if (!isEmpty(tail(tail(matchValue_37)))) {
                                if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                    if (head(matchValue_37) !== width_11) {
                                        matchResult_31 = 1;
                                        n_173 = head(matchValue_37);
                                    }
                                    else if (head(tail(matchValue_37)) !== 1) {
                                        matchResult_31 = 2;
                                        n_174 = head(tail(matchValue_37));
                                    }
                                    else if (head(tail(tail(matchValue_37))) != null) {
                                        if (head(tail(tail(matchValue_37))) !== 1) {
                                            matchResult_31 = 3;
                                            n_175 = head(tail(tail(matchValue_37)));
                                        }
                                        else {
                                            matchResult_31 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_31 = 4;
                                    }
                                }
                                else {
                                    matchResult_31 = 5;
                                }
                            }
                            else {
                                matchResult_31 = 5;
                            }
                        }
                        else if (!isEmpty(tail(tail(matchValue_37)))) {
                            if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                if (head(matchValue_37) !== width_11) {
                                    matchResult_31 = 1;
                                    n_173 = head(matchValue_37);
                                }
                                else if (head(tail(tail(matchValue_37))) != null) {
                                    if (head(tail(tail(matchValue_37))) !== 1) {
                                        matchResult_31 = 3;
                                        n_175 = head(tail(tail(matchValue_37)));
                                    }
                                    else {
                                        matchResult_31 = 4;
                                    }
                                }
                                else {
                                    matchResult_31 = 4;
                                }
                            }
                            else {
                                matchResult_31 = 5;
                            }
                        }
                        else {
                            matchResult_31 = 5;
                        }
                    }
                    else {
                        matchResult_31 = 5;
                    }
                }
                else if (!isEmpty(tail(matchValue_37))) {
                    if (head(tail(matchValue_37)) != null) {
                        if (!isEmpty(tail(tail(matchValue_37)))) {
                            if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                if (head(tail(matchValue_37)) !== 1) {
                                    matchResult_31 = 2;
                                    n_174 = head(tail(matchValue_37));
                                }
                                else if (head(tail(tail(matchValue_37))) != null) {
                                    if (head(tail(tail(matchValue_37))) !== 1) {
                                        matchResult_31 = 3;
                                        n_175 = head(tail(tail(matchValue_37)));
                                    }
                                    else {
                                        matchResult_31 = 4;
                                    }
                                }
                                else {
                                    matchResult_31 = 4;
                                }
                            }
                            else {
                                matchResult_31 = 5;
                            }
                        }
                        else {
                            matchResult_31 = 5;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_37)))) {
                        if (head(tail(tail(matchValue_37))) != null) {
                            if (isEmpty(tail(tail(tail(matchValue_37))))) {
                                if (head(tail(tail(matchValue_37))) !== 1) {
                                    matchResult_31 = 3;
                                    n_175 = head(tail(tail(matchValue_37)));
                                }
                                else {
                                    matchResult_31 = 4;
                                }
                            }
                            else {
                                matchResult_31 = 5;
                            }
                        }
                        else if (isEmpty(tail(tail(tail(matchValue_37))))) {
                            matchResult_31 = 4;
                        }
                        else {
                            matchResult_31 = 5;
                        }
                    }
                    else {
                        matchResult_31 = 5;
                    }
                }
                else {
                    matchResult_31 = 5;
                }
            }
            else {
                matchResult_31 = 5;
            }
            switch (matchResult_31) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_68, y_57) => (compare(x_68, y_57) | 0),
                    }), getOutputPortId(comp, 0), width_11)]);
                case 1:
                    return makeWidthInferErrorEqual(width_11, n_173, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return makeWidthInferErrorEqual(1, n_174, singleton(getConnectionIdForPort_1(1)));
                case 3:
                    return makeWidthInferErrorEqual(1, n_175, singleton(getConnectionIdForPort_1(2)));
                case 4:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_69, y_58) => (compare(x_69, y_58) | 0),
                    }), getOutputPortId(comp, 0), width_11)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 39: {
            const width_12 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 2, comp);
            const matchValue_38 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1]));
            let matchResult_32, n_183, n_184, n_185;
            if (!isEmpty(matchValue_38)) {
                if (head(matchValue_38) != null) {
                    if (!isEmpty(tail(matchValue_38))) {
                        if (head(tail(matchValue_38)) != null) {
                            if (head(tail(matchValue_38)) === 1) {
                                if (isEmpty(tail(tail(matchValue_38)))) {
                                    if (head(matchValue_38) === width_12) {
                                        matchResult_32 = 0;
                                        n_183 = head(matchValue_38);
                                    }
                                    else if (head(matchValue_38) !== width_12) {
                                        matchResult_32 = 1;
                                        n_184 = head(matchValue_38);
                                    }
                                    else if (head(tail(matchValue_38)) !== 1) {
                                        matchResult_32 = 2;
                                        n_185 = head(tail(matchValue_38));
                                    }
                                    else {
                                        matchResult_32 = 3;
                                    }
                                }
                                else {
                                    matchResult_32 = 4;
                                }
                            }
                            else if (isEmpty(tail(tail(matchValue_38)))) {
                                if (head(matchValue_38) !== width_12) {
                                    matchResult_32 = 1;
                                    n_184 = head(matchValue_38);
                                }
                                else if (head(tail(matchValue_38)) !== 1) {
                                    matchResult_32 = 2;
                                    n_185 = head(tail(matchValue_38));
                                }
                                else {
                                    matchResult_32 = 3;
                                }
                            }
                            else {
                                matchResult_32 = 4;
                            }
                        }
                        else if (isEmpty(tail(tail(matchValue_38)))) {
                            if (head(matchValue_38) !== width_12) {
                                matchResult_32 = 1;
                                n_184 = head(matchValue_38);
                            }
                            else {
                                matchResult_32 = 3;
                            }
                        }
                        else {
                            matchResult_32 = 4;
                        }
                    }
                    else {
                        matchResult_32 = 4;
                    }
                }
                else if (!isEmpty(tail(matchValue_38))) {
                    if (head(tail(matchValue_38)) != null) {
                        if (isEmpty(tail(tail(matchValue_38)))) {
                            if (head(tail(matchValue_38)) !== 1) {
                                matchResult_32 = 2;
                                n_185 = head(tail(matchValue_38));
                            }
                            else {
                                matchResult_32 = 3;
                            }
                        }
                        else {
                            matchResult_32 = 4;
                        }
                    }
                    else if (isEmpty(tail(tail(matchValue_38)))) {
                        matchResult_32 = 3;
                    }
                    else {
                        matchResult_32 = 4;
                    }
                }
                else {
                    matchResult_32 = 4;
                }
            }
            else {
                matchResult_32 = 4;
            }
            switch (matchResult_32) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_70, y_59) => (compare(x_70, y_59) | 0),
                    }), getOutputPortId(comp, 0), width_12)]);
                case 1:
                    return makeWidthInferErrorEqual(width_12, n_184, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return makeWidthInferErrorEqual(1, n_185, singleton(getConnectionIdForPort_1(1)));
                case 3:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_71, y_60) => (compare(x_71, y_60) | 0),
                    }), getOutputPortId(comp, 0), width_12)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 40: {
            const width_13 = matchValue.fields[0] | 0;
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_39 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_33, n_187;
            if (!isEmpty(matchValue_39)) {
                if (head(matchValue_39) != null) {
                    if (head(matchValue_39) === 1) {
                        if (isEmpty(tail(matchValue_39))) {
                            matchResult_33 = 0;
                        }
                        else {
                            matchResult_33 = 3;
                        }
                    }
                    else if (isEmpty(tail(matchValue_39))) {
                        if (head(matchValue_39) !== 1) {
                            matchResult_33 = 1;
                            n_187 = head(matchValue_39);
                        }
                        else {
                            matchResult_33 = 2;
                        }
                    }
                    else {
                        matchResult_33 = 3;
                    }
                }
                else if (isEmpty(tail(matchValue_39))) {
                    matchResult_33 = 2;
                }
                else {
                    matchResult_33 = 3;
                }
            }
            else {
                matchResult_33 = 3;
            }
            switch (matchResult_33) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_72, y_61) => (compare(x_72, y_61) | 0),
                    }), getOutputPortId(comp, 0), width_13)]);
                case 1:
                    return makeWidthInferErrorEqual(1, n_187, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_73, y_62) => (compare(x_73, y_62) | 0),
                    }), getOutputPortId(comp, 0), width_13)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        case 41: {
            assertInputsSize(inputConnectionsWidth, 0, comp);
            return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                Compare: (x_74, y_63) => (compare(x_74, y_63) | 0),
            }), getOutputPortId(comp, 0), matchValue.fields[0])]);
        }
        case 42: {
            assertInputsSize(inputConnectionsWidth, 1, comp);
            const matchValue_40 = getWidthsForPorts(inputConnectionsWidth, singleton(0));
            let matchResult_34, aw_2, aw_3;
            if (!isEmpty(matchValue_40)) {
                if (head(matchValue_40) != null) {
                    if (isEmpty(tail(matchValue_40))) {
                        if (head(matchValue_40) === mem.AddressWidth) {
                            matchResult_34 = 1;
                            aw_2 = head(matchValue_40);
                        }
                        else if (head(matchValue_40) !== mem.AddressWidth) {
                            matchResult_34 = 2;
                            aw_3 = head(matchValue_40);
                        }
                        else {
                            matchResult_34 = 3;
                        }
                    }
                    else {
                        matchResult_34 = 3;
                    }
                }
                else if (isEmpty(tail(matchValue_40))) {
                    matchResult_34 = 0;
                }
                else {
                    matchResult_34 = 3;
                }
            }
            else {
                matchResult_34 = 3;
            }
            switch (matchResult_34) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_75, y_64) => (compare(x_75, y_64) | 0),
                    }), getOutputPortId(comp, 0), mem.WordWidth)]);
                case 1:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_76, y_65) => (compare(x_76, y_65) | 0),
                    }), getOutputPortId(comp, 0), mem.WordWidth)]);
                case 2:
                    return makeWidthInferErrorEqual(mem.AddressWidth, aw_3, singleton(getConnectionIdForPort_1(0)));
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
        default: {
            assertInputsSize(inputConnectionsWidth, 3, comp);
            const matchValue_41 = getWidthsForPorts(inputConnectionsWidth, ofArray([0, 1, 2]));
            let matchResult_35, addr_4, datain_4, write_5, addr_5, datain_5, write_6;
            if (!isEmpty(matchValue_41)) {
                if (head(matchValue_41) != null) {
                    if (!isEmpty(tail(matchValue_41))) {
                        if (head(tail(matchValue_41)) != null) {
                            if (!isEmpty(tail(tail(matchValue_41)))) {
                                if (head(tail(tail(matchValue_41))) != null) {
                                    if (isEmpty(tail(tail(tail(matchValue_41))))) {
                                        if ((write = (head(tail(tail(matchValue_41))) | 0), (datain = (head(tail(matchValue_41)) | 0), ((head(matchValue_41) === mem_1.AddressWidth) && (datain === mem_1.WordWidth)) && (write === 1)))) {
                                            matchResult_35 = 0;
                                            addr_4 = head(matchValue_41);
                                            datain_4 = head(tail(matchValue_41));
                                            write_5 = head(tail(tail(matchValue_41)));
                                        }
                                        else if (head(matchValue_41) !== mem_1.AddressWidth) {
                                            matchResult_35 = 1;
                                            addr_5 = head(matchValue_41);
                                        }
                                        else if (head(tail(matchValue_41)) !== mem_1.WordWidth) {
                                            matchResult_35 = 2;
                                            datain_5 = head(tail(matchValue_41));
                                        }
                                        else if (head(tail(tail(matchValue_41))) !== 1) {
                                            matchResult_35 = 3;
                                            write_6 = head(tail(tail(matchValue_41)));
                                        }
                                        else {
                                            matchResult_35 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_35 = 5;
                                    }
                                }
                                else if (isEmpty(tail(tail(tail(matchValue_41))))) {
                                    if (head(matchValue_41) !== mem_1.AddressWidth) {
                                        matchResult_35 = 1;
                                        addr_5 = head(matchValue_41);
                                    }
                                    else if (head(tail(matchValue_41)) !== mem_1.WordWidth) {
                                        matchResult_35 = 2;
                                        datain_5 = head(tail(matchValue_41));
                                    }
                                    else {
                                        matchResult_35 = 4;
                                    }
                                }
                                else {
                                    matchResult_35 = 5;
                                }
                            }
                            else {
                                matchResult_35 = 5;
                            }
                        }
                        else if (!isEmpty(tail(tail(matchValue_41)))) {
                            if (isEmpty(tail(tail(tail(matchValue_41))))) {
                                if (head(matchValue_41) !== mem_1.AddressWidth) {
                                    matchResult_35 = 1;
                                    addr_5 = head(matchValue_41);
                                }
                                else if (head(tail(tail(matchValue_41))) != null) {
                                    if (head(tail(tail(matchValue_41))) !== 1) {
                                        matchResult_35 = 3;
                                        write_6 = head(tail(tail(matchValue_41)));
                                    }
                                    else {
                                        matchResult_35 = 4;
                                    }
                                }
                                else {
                                    matchResult_35 = 4;
                                }
                            }
                            else {
                                matchResult_35 = 5;
                            }
                        }
                        else {
                            matchResult_35 = 5;
                        }
                    }
                    else {
                        matchResult_35 = 5;
                    }
                }
                else if (!isEmpty(tail(matchValue_41))) {
                    if (head(tail(matchValue_41)) != null) {
                        if (!isEmpty(tail(tail(matchValue_41)))) {
                            if (isEmpty(tail(tail(tail(matchValue_41))))) {
                                if (head(tail(matchValue_41)) !== mem_1.WordWidth) {
                                    matchResult_35 = 2;
                                    datain_5 = head(tail(matchValue_41));
                                }
                                else if (head(tail(tail(matchValue_41))) != null) {
                                    if (head(tail(tail(matchValue_41))) !== 1) {
                                        matchResult_35 = 3;
                                        write_6 = head(tail(tail(matchValue_41)));
                                    }
                                    else {
                                        matchResult_35 = 4;
                                    }
                                }
                                else {
                                    matchResult_35 = 4;
                                }
                            }
                            else {
                                matchResult_35 = 5;
                            }
                        }
                        else {
                            matchResult_35 = 5;
                        }
                    }
                    else if (!isEmpty(tail(tail(matchValue_41)))) {
                        if (head(tail(tail(matchValue_41))) != null) {
                            if (isEmpty(tail(tail(tail(matchValue_41))))) {
                                if (head(tail(tail(matchValue_41))) !== 1) {
                                    matchResult_35 = 3;
                                    write_6 = head(tail(tail(matchValue_41)));
                                }
                                else {
                                    matchResult_35 = 4;
                                }
                            }
                            else {
                                matchResult_35 = 5;
                            }
                        }
                        else if (isEmpty(tail(tail(tail(matchValue_41))))) {
                            matchResult_35 = 4;
                        }
                        else {
                            matchResult_35 = 5;
                        }
                    }
                    else {
                        matchResult_35 = 5;
                    }
                }
                else {
                    matchResult_35 = 5;
                }
            }
            else {
                matchResult_35 = 5;
            }
            switch (matchResult_35) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_77, y_66) => (compare(x_77, y_66) | 0),
                    }), getOutputPortId(comp, 0), mem_1.WordWidth)]);
                case 1:
                    return makeWidthInferErrorEqual(mem_1.AddressWidth, addr_5, singleton(getConnectionIdForPort_1(0)));
                case 2:
                    return makeWidthInferErrorEqual(mem_1.WordWidth, datain_5, singleton(getConnectionIdForPort_1(1)));
                case 3:
                    return makeWidthInferErrorEqual(1, write_6, singleton(getConnectionIdForPort_1(2)));
                case 4:
                    return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(empty_1({
                        Compare: (x_78, y_67) => (compare(x_78, y_67) | 0),
                    }), getOutputPortId(comp, 0), mem_1.WordWidth)]);
                default:
                    return toFail(printf("what? Impossible case in calculateOutputPortsWidth for: %A"))(comp.Type);
            }
        }
    }
}

function findConnectionToInputPort(inputPortIdsToConnectionIds, portId) {
    return FSharpMap__TryFind(inputPortIdsToConnectionIds, portId);
}

function findConnectionsFromOutputPort(outputPortIdsToConnections, portId) {
    return FSharpMap__TryFind(outputPortIdsToConnections, portId);
}

/**
 * Lookup the width of a connection in the connectionsWidth map or fail.
 */
export function getConnectionWidth(connectionsWidth, connId) {
    const matchValue = FSharpMap__TryFind(connectionsWidth, connId);
    if (matchValue != null) {
        return value_1(matchValue);
    }
    else {
        return toFail(printf("what? getConnectionWidth received inexistent connectionId: %A"))(connId);
    }
}

function getInputPortsConnectionsWidth(connectionsWidth, currNode, inputPortIdsToConnectionIds) {
    return ofList_1(map_2((inputPort) => {
        const _arg = findConnectionToInputPort(inputPortIdsToConnectionIds, inputPort.Id);
        if (_arg == null) {
            return [extractComponentPortNumber(inputPort), undefined];
        }
        else {
            const connId = _arg;
            return [extractComponentPortNumber(inputPort), [getConnectionWidth(connectionsWidth, connId), connId]];
        }
    }, currNode.InputPorts), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

function setConnectionWidth(connectionId, connectionWidth, connectionsWidth) {
    return FSharpMap__Add(connectionsWidth, connectionId, connectionWidth);
}

function setConnectionsWidth(connections, connWidth, connectionsWidth) {
    return fold((res, conn) => Result_Bind((tupledArg) => {
        const connectionsWidth_1 = tupledArg[0];
        const connectionsToReturn = tupledArg[1];
        const connId = conn.Id;
        const matchValue = getConnectionWidth(connectionsWidth_1, connId);
        if (matchValue != null) {
            if (matchValue === connWidth) {
                const oldWidth_2 = matchValue | 0;
                return new FSharpResult$2(/* Ok */ 0, [[connectionsWidth_1, connectionsToReturn]]);
            }
            else if (matchValue !== connWidth) {
                const oldWidth_3 = matchValue | 0;
                return new FSharpResult$2(/* Error */ 1, [new WidthInferError(toText(printf("Wire has been inferred to have two different widths: %d and %d. This is probably due to an error such as a combinatorial loop."))(oldWidth_3)(connWidth), singleton(connId))]);
            }
            else {
                return toFail(printf("what? Impossible case in setConnectionsWidth."));
            }
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [[setConnectionWidth(connId, connWidth, connectionsWidth_1), cons(conn, connectionsToReturn)]]);
        }
    }, res), new FSharpResult$2(/* Ok */ 0, [[connectionsWidth, empty()]]), connections);
}

function getComponentFromId(compId, compIdsToComps) {
    const matchValue = FSharpMap__TryFind(compIdsToComps, compId);
    if (matchValue != null) {
        return matchValue;
    }
    else {
        return toFail(printf("what? getComponentFromId called with invalid componentId: %A"))(compId);
    }
}

function infer(staticMaps_, staticMaps__1, staticMaps__2, staticMaps__3, currNode, connectionsWidth) {
    const staticMaps_1 = [staticMaps_, staticMaps__1, staticMaps__2, staticMaps__3];
    return Result_Bind((outputPortsWidths) => fold_1((connectionsWidthRes_1, outPortId, connWidth) => Result_Bind((connectionsWidth_3) => {
        const matchValue = findConnectionsFromOutputPort(staticMaps_1[1], outPortId);
        if (matchValue != null) {
            return Result_Bind((tupledArg) => fold((connectionsWidthRes, child) => Result_Bind((connectionsWidth_2) => infer(staticMaps_1[0], staticMaps_1[1], staticMaps_1[2], staticMaps_1[3], child, connectionsWidth_2), connectionsWidthRes), new FSharpResult$2(/* Ok */ 0, [tupledArg[0]]), map_2((conn) => getComponentFromId(conn.Target.HostId, staticMaps_1[2]), tupledArg[1])), setConnectionsWidth(matchValue, connWidth, connectionsWidth_3));
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [connectionsWidth_3]);
        }
    }, connectionsWidthRes_1), new FSharpResult$2(/* Ok */ 0, [connectionsWidth]), outputPortsWidths), calculateOutputPortsWidth(currNode, staticMaps_1[3], getInputPortsConnectionsWidth(connectionsWidth, currNode, staticMaps_1[0])));
}

function initialiseConnectionsWidth(connections) {
    return ofList_1(map_2((conn) => [conn.Id, undefined], connections), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

function getAllInputNodes(components) {
    return filter((comp) => {
        if (comp.Type.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, components);
}

function mapInputPortIdsToConnectionIds(connections) {
    return fold((mapRes, conn) => Result_Bind((map) => {
        const inputPortId = conn.Target.Id;
        const connId = conn.Id;
        const matchValue = FSharpMap__TryFind(map, inputPortId);
        if (matchValue != null) {
            return new FSharpResult$2(/* Error */ 1, [new WidthInferError("A wire must have precisely one driving component. If you want to merge two wires together, use a MergeWires component.", ofArray([connId, matchValue]))]);
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [FSharpMap__Add(map, inputPortId, connId)]);
        }
    }, mapRes), new FSharpResult$2(/* Ok */ 0, [empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    })]), connections);
}

function mapComponentIdsToComponents(components) {
    return ofList_1(map_2((comp) => [comp.Id, comp], components), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

function mapOutputPortIdsToConnections(connections) {
    return ofList_1(List_groupBy((conn) => conn.Source.Id, connections, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
}

function mapInputPortIdsToVirtualConnectionIds(conns, comps) {
    const mapPortIdToConnId = mapInputPortIdsToConnectionIds(conns);
    const filteredComps = filter((comp) => equals(comp.Type, ComponentType.IOLabel), comps);
    const targetPortIdToConId = ofList_1(map_2((conn) => [conn.Target.Id, conn.Id], conns), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const mapLabels = Result_Map((arg_2) => ofList_1(concat(arg_2), {
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    }), ResultList_sequence(map_2((tupledArg) => {
        let arg_1;
        const compLst_1 = tupledArg[1];
        const matchValue = collect((comp_1) => {
            const _arg = tryFind_1(item(0, comp_1.InputPorts).Id, targetPortIdToConId);
            if (_arg != null) {
                return singleton(_arg);
            }
            else {
                return empty();
            }
        }, compLst_1);
        let matchResult, cId_1, h_2;
        if (!isEmpty(matchValue)) {
            if (isEmpty(tail(matchValue))) {
                matchResult = 0;
                cId_1 = head(matchValue);
            }
            else if (length(matchValue) !== 1) {
                matchResult = 1;
                h_2 = matchValue;
            }
            else {
                matchResult = 2;
            }
        }
        else if (length(matchValue) !== 1) {
            matchResult = 1;
            h_2 = matchValue;
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return new FSharpResult$2(/* Ok */ 0, [map_2((comp_3) => [item(0, comp_3.InputPorts).Id, cId_1], compLst_1)]);
            case 1:
                return new FSharpResult$2(/* Error */ 1, [new WidthInferError((arg_1 = (length(h_2) | 0), toText(printf("A net label must have exactly one driving component but the label \'%s\' has %d"))(tupledArg[0])(arg_1)), h_2)]);
            default:
                return new FSharpResult$2(/* Ok */ 0, [empty()]);
        }
    }, List_groupBy((comp_2) => comp_2.Label, filteredComps, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }))));
    let matchResult_1, e, map, mapL;
    const copyOfStruct = mapPortIdToConnId;
    if (copyOfStruct.tag === 0) {
        const copyOfStruct_1 = mapLabels;
        if (copyOfStruct_1.tag === 0) {
            matchResult_1 = 1;
            map = copyOfStruct.fields[0];
            mapL = copyOfStruct_1.fields[0];
        }
        else {
            matchResult_1 = 0;
            e = copyOfStruct_1.fields[0];
        }
    }
    else {
        matchResult_1 = 0;
        e = copyOfStruct.fields[0];
    }
    switch (matchResult_1) {
        case 0:
            return new FSharpResult$2(/* Error */ 1, [e]);
        default:
            return new FSharpResult$2(/* Ok */ 0, [ofList_1(collect((pId) => {
                const matchValue_2 = tryFind_1(pId, map);
                const matchValue_3 = tryFind_1(pId, mapL);
                let matchResult_2, conn_1;
                if (matchValue_2 != null) {
                    if (matchValue_3 == null) {
                        matchResult_2 = 1;
                        conn_1 = matchValue_2;
                    }
                    else {
                        matchResult_2 = 1;
                        conn_1 = matchValue_3;
                    }
                }
                else if (matchValue_3 != null) {
                    matchResult_2 = 1;
                    conn_1 = matchValue_3;
                }
                else {
                    matchResult_2 = 0;
                }
                switch (matchResult_2) {
                    case 0:
                        return empty();
                    default:
                        return singleton([pId, conn_1]);
                }
            }, map_2((p) => p.Id, collect((comp_4) => comp_4.InputPorts, comps))), {
                Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
            })]);
    }
}

/**
 * Return Inferred width of all connections or an error.
 * Width inference is done without mutable state.
 * It is to be run when component widths or circuit is changed,
 * Note that it does not matter (except for performance) if it is run too many times.
 */
export function inferConnectionsWidth(_arg1_, _arg1__1) {
    let matchValue, staticMapComponentIdsToComponents, staticMaps;
    const _arg = [_arg1_, _arg1__1];
    const conns = _arg[1];
    const comps = _arg[0];
    const start = getTimeMs();
    const connectionsWidth = initialiseConnectionsWidth(conns);
    return instrumentInterval("widthInference", start, (matchValue = mapInputPortIdsToVirtualConnectionIds(conns, comps), (matchValue.tag === 0) ? ((staticMapComponentIdsToComponents = mapComponentIdsToComponents(comps), (staticMaps = [matchValue.fields[0], mapOutputPortIdsToConnections(conns), staticMapComponentIdsToComponents, makeOutputPortsOfLabels(comps)], fold((connectionsWidthRes, inputNode) => Result_Bind((connectionsWidth_1) => infer(staticMaps[0], staticMaps[1], staticMaps[2], staticMaps[3], inputNode, connectionsWidth_1), connectionsWidthRes), new FSharpResult$2(/* Ok */ 0, [connectionsWidth]), comps)))) : (new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]]))));
}

